var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _g2, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _g3, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignUpIllNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 451,
    viewBox: "0 0 531 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.201 367.1C339.901 367.1 398.101 309 398.101 237.2C398.101 165.5 340.001 107.3 268.201 107.3C196.401 107.3 138.301 165.4 138.301 237.2C138.301 308.9 196.501 367.1 268.201 367.1Z",
    fill: "url(#paint0_linear_6686_51309)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M399.101 237.2C399.101 309 341.001 367.1 269.201 367.1C221.801 367.1 180.401 341.7 157.701 303.8C221.301 344.6 310.001 331.6 366.201 269.8C379.901 254.7 390.501 237.9 398.101 220.3C398.701 225.9 399.101 231.5 399.101 237.2Z",
    fill: "#0C74C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M336.8 204.9C342.8 204.9 347.7 200 347.7 194C347.7 188 342.8 183.1 336.8 183.1C330.8 183.1 325.9 188 325.9 194C325.9 200 330.7 204.9 336.8 204.9Z",
    fill: "#D3D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M320.901 181.9C323.201 181.9 325.101 180 325.101 177.7C325.101 175.4 323.201 173.5 320.901 173.5C318.601 173.5 316.701 175.4 316.701 177.7C316.701 180 318.601 181.9 320.901 181.9Z",
    fill: "#D3D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M226.8 139.3C229.5 139.3 231.6 137.1 231.6 134.5C231.6 131.8 229.4 129.7 226.8 129.7C224.1 129.7 222 131.9 222 134.5C222 137.1 224.1 139.3 226.8 139.3Z",
    fill: "#D3D3D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158 306.1C159.4 303.5 162.9 303.8 163.6 306.8C163.8 307.7 164.2 308.4 164.7 309.1C165.6 307.9 166.3 306.5 166.9 305.1C167.9 302.8 171.3 302.6 172.3 305.1C172.5 305.6 173.1 307.6 173.7 308C173.7 308 173.8 307.9 174 307.8C175.6 307.1 177 305.1 178.2 303.9C179.3 302.8 181.4 303.2 182.3 304.4C183.5 306.1 184 306.1 186.1 305.8C187.4 305.6 188.7 306.4 189.2 307.5C190.2 309.9 190.9 312.4 192.5 314.4C192.7 314.2 192.9 314 193.1 313.8C193.7 312.9 194.8 312.5 195.8 312.6C196.4 312.7 196.9 312.8 197.3 313C198.9 311.8 200.8 311.1 202.7 310.6C203.4 310.4 204.1 310.2 204.7 310.1C205 310.1 205.2 310 205.5 309.9C205.6 309.6 206 309 206 309C206.4 308.4 207 308 207.6 307.6C211.9 305 216.6 308.5 220.9 310.1C221.2 308.2 220.6 306.1 219.9 304.3C219.2 302.5 220.3 300.6 222.2 300.3C223.9 300 225.6 300.1 227.3 300C228.4 300 228.3 300 228.8 298.9C230 296.4 227.5 292.4 226.8 289.9C226.4 288.6 226.6 287.5 227.7 286.5C228.9 285.4 228 283.7 227.2 282.7C226.1 281.2 226.6 278.9 228.4 278.2C228.8 278 229.2 277.9 229.6 277.7C227.1 276 224.2 274.7 221.9 272.8C220.2 271.4 220.5 267.6 223.3 267.6C224.7 267.6 226 267.5 227.4 267.2C227.2 266.9 227.1 266.7 226.9 266.5C226.3 265.7 225.7 265 225 264.2C222.2 261.2 218.3 258.4 217 254.4C216.3 252.3 216.4 249.7 218.7 248.6C220.4 247.8 222.2 248.4 223.8 249.2C225.8 250.1 227.6 251.4 229.5 252.6C230 252.9 230.5 253.2 231 253.6C231.5 252.1 231.7 250.6 231.7 248.9C231.7 246.5 234.6 246 236.3 246.9C238.2 248 241.4 250.3 243.7 248.9C245.1 248 246.3 248.2 247.5 249.2C249.9 247.3 252.6 246.4 255.4 246.9C255.2 243.8 253.3 240.7 251.9 238.1C249.9 234.3 248.1 230.5 248.5 226.1C248.6 224.6 250.2 223.3 251.7 223.6C252.9 223.8 254.2 224.1 255.4 224.4C254.7 223.5 253.9 222.6 253.1 221.9C250.5 219.4 253.6 214.8 256.6 217.2C257.2 217.7 257.8 218.2 258.3 218.7C261.4 221.4 264.6 223.9 266.4 227.8C266.8 228.6 266.7 229.4 266.4 230C266.7 230.5 267.1 231 267.5 231.5C268.4 232.7 270.7 236.2 272.4 236.1C273.3 236 274 234.6 274.5 233.8C275.4 232.4 276.2 230.9 277.2 229.7C278.3 228.4 280.8 227.9 281.8 229.7C282.7 231.3 284.4 234.6 286.6 233.2C287.7 232.5 289 232.3 290.1 233.2C292.5 235.1 293.5 237.6 293.9 240.6C294.2 243.2 294.2 245.5 296.9 246.7C299.5 247.9 299.2 251.9 296.2 252.3C295.6 252.4 295 252.5 294.4 252.6C296.7 253.8 298.8 255.3 299.5 258.1C299.8 259.4 299.7 260.7 299.2 262C299.1 262.3 298.7 262.9 298.6 263.4C298.7 263.2 299.4 264.3 299.5 264.4C300.9 266.2 303.2 266.9 305.3 267.6C306.9 268.2 307.8 270.7 306.6 272C304.8 273.9 300.2 283.7 304.6 284.2C306.1 284.4 306.9 285.5 307 286.8C308.2 287.6 309.1 288.5 309.6 289.9C310.2 291.4 309.6 292.8 309.7 294.2C309.7 293.8 310 294.9 310 294.8C310 294.8 310 294.9 310.1 295C310.4 295.7 310.8 296.5 311.2 297.2C311.8 298.3 312.3 299.3 312.9 300.4C313.2 301 313.3 301.6 313.1 302.1C313.2 302.6 313.3 303.2 313.4 303.7C313.6 304.7 313.8 305.7 313.8 306.8C313.8 306.9 313.8 307 313.8 307.1C315.2 308.6 317.4 310.2 319.3 309.3C320.3 308.8 321.1 307.9 322.1 307.3C323.1 306.7 324.1 306.4 325.2 306.1C326.5 305.7 328.8 305.2 329.6 304.9C329.6 304.7 329.6 304.5 329.6 304.3C329.6 302.7 329.6 301.8 329 300.4C328.4 298.8 327.2 297.5 327.5 295.7C327.6 294.9 328.2 293.4 328.8 292.8C328.7 292.3 328.7 291.9 328.5 291.4C327.8 289.1 325.9 287.2 324.5 285.3C323.6 284.2 323.8 282.9 324.5 281.8C326.7 277.9 321.9 274.4 319.2 272.5C317.6 271.4 317.7 269 319.2 267.9C320.1 267.2 321 266.5 321.9 265.9C320.2 264.2 321.5 260.4 324.3 261C326.6 261.5 328.9 262 331.2 262.5C333.4 262.9 334.2 265.7 333.2 267.2C337.5 272.1 340.7 278.4 346.4 281.9C347.2 282.4 347.8 283.6 347.6 284.6C347 287.5 348.5 290.3 349.1 293.1C349.7 296.4 349.1 299.5 347.7 302.4C348.5 303.5 349.4 304.6 350.4 304.7C350.5 304.7 351.5 304 351.9 303.6C354.2 301.6 356.8 299.5 358.8 297.2C359.1 296.9 359.6 296.2 359.7 296.1L359.9 295.5C359.9 295.1 359.8 294.6 359.6 293.8C359 290.9 358.4 288.1 358.2 285.1C358.1 283.7 359 281.9 360.7 281.8C363.2 281.7 363.4 281.2 362.4 278.9C361.6 277.2 362.9 275.1 364.7 274.9C368.2 274.6 371.8 274.4 375.4 274.3C374.1 272.8 372.8 271.4 371.7 269.7C370.7 268.3 371 265.9 372.9 265.2C375 264.5 377.1 263.8 379.2 263.1C378.9 262.1 379.2 261.1 380 260.3C379.1 260.2 378.1 259.4 377.8 258.6C377.2 256.3 374.3 254.8 372.5 253.6C369.7 251.8 366.8 250.1 364.1 248.2C361.8 246.5 359.9 244.4 358.1 242.2C356.7 240.5 354.5 237.2 352.4 238.4C351 239.2 349.2 238.1 348.6 236.8C347.3 234.1 344.8 232.2 343.5 229.4C342.2 226.8 341.9 224 341.9 221.2C341.9 219.1 342 217 341.6 214.9C341.3 215.2 340.9 215.4 340.7 215.6C338.2 218 334.9 214.2 336.6 211.6C337.7 210 338.1 209.2 336.2 208.7C334.8 208.4 333.9 208.8 332.9 209.7C330.5 211.7 328.9 214.8 327.4 217.5C326.7 218.8 324.4 219.1 323.4 218.1C321.8 216.6 319.9 215.9 319.8 213.5C319.7 210.4 320.7 207.1 321.4 204.1C322.6 199.1 324 193.1 321.1 188.5C320.1 187 318.5 186.1 317.1 184.9C315.1 183.3 313.1 181.3 311.9 179.1C311.1 177.5 311 175.9 310.7 174.2C310.5 173.3 310.1 172.8 309.5 172.5C307.7 175.3 304.5 176.6 301 176.7C298.8 176.7 296.7 176.5 294.5 176.4C293.4 176.3 291.9 176.2 290.7 176.5C290.5 177.7 290.4 178.8 290 179.9C289.3 182.1 287.6 183.6 286 185.1C284.3 186.6 283.5 188 284 190.3C284.4 192.1 284.6 193.7 284.1 195.2C286.1 197.3 288.1 199.4 290 201.6C291.7 203.5 293.4 205.1 295.3 206.9C297.3 208.8 299.3 211.1 299.9 213.9C300.5 217.2 298.8 218.9 295.8 219.8C287.7 222.1 275.6 216.4 272.6 208.2C272 208.1 271.4 208.1 270.9 207.9C269.7 207.6 268.9 206 269.1 204.9C268.3 205.1 267.6 205.4 266.8 205.6C264.1 206.4 260.7 207.2 258.4 205.1C258.3 205 258.2 204.9 258.1 204.8C256.5 204.7 255 204.4 253.6 203.7C252 202.8 250.9 201.6 250.2 200.1C248.6 199.8 247.3 198.3 248 196.3C248.8 194.1 250 192.1 252.3 191.4C254 190.9 255.5 191.4 257.1 191.6C259.5 191.9 261.5 190.4 263.7 189.6C265.1 189 266.6 188.7 268 188.8C269.9 183.8 273.9 179.5 278 176.1C277.6 174.7 277.1 173.3 276.2 172.5C274.7 171.2 274.8 168.8 276.3 167.8C276.1 167.5 275.9 167.1 275.8 166.8C275.4 165.9 275.5 164.7 276.1 163.9C277.9 161.7 280.4 160.1 282.5 158.2C283.8 157 284.5 156.3 283.4 154.4C282.1 152.3 279.5 150.9 277.4 149.6C275.8 148.7 274.2 147.8 272.7 146.8C270.8 148.4 267.2 147.5 267.8 144.5C268 143.6 268.3 142.8 267.7 142.1C267.4 141.6 266.6 141.2 266 140.9C264.7 140.8 263.4 140.3 262.2 140C260.2 139.5 258.2 139 256.2 138.6C250.6 137.3 244.1 138.4 238.7 140.4C235.7 141.5 233.1 142.9 230.7 145C228.8 146.7 226.4 149.1 223.6 148.8C222 148.6 220.7 147.7 219.6 146.6C218.7 145.6 218.4 145.4 217.1 145C216.1 144.7 215 143.9 213.9 144.2C212.8 144.5 212.5 145.7 212.1 146.6C210.9 149.2 209.8 151.3 207.7 153.2C205.1 155.5 201.9 157 199.3 159.1C197.2 160.8 194.6 158.8 194.6 156.5C194.6 154.8 194.7 153.2 195.1 151.6C194 150.7 193.7 148.8 194.7 147.7C197.5 144.3 201.1 141.7 204.2 138.7C206 137 210.3 133.1 208.1 130.4C207 129.2 207.4 127.5 208.5 126.5C207.9 125.7 207.3 124.9 206.7 124.1C166.3 146.1 138.9 189 138.9 238.2C138.9 263.4 146.1 287 158.6 306.9C157.9 306.2 157.9 306.1 158 306.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M380.201 223.8C377.601 222.6 374.901 221.7 372.301 220.4C369.801 219.2 370.001 215.2 373.001 214.8C374.701 214.6 376.501 214.3 378.101 213.8C378.701 213.6 379.501 213.4 380.101 213.1C380.401 213 380.701 212.8 381.001 212.7C381.001 212.7 381.401 212.5 381.501 212.4C381.801 212.2 382.101 212.1 382.301 211.8C382.301 211.8 382.401 211.7 382.501 211.6V211.5C382.501 211.4 382.301 211.1 382.301 211.1C382.501 211.4 382.001 210.7 381.901 210.6C381.301 209.8 380.401 209.1 379.601 208.5C377.301 206.8 374.201 205.9 371.401 206.2C370.201 206.3 369.001 206.7 368.201 207.2C367.301 207.9 366.701 208.7 366.401 210.1C366.101 211.6 364.801 212.8 363.201 212.6C362.401 212.5 361.601 212 361.101 211.2C360.701 211.3 360.401 211.5 360.201 211.6C360.201 211.6 360.201 211.6 360.201 211.7C360.501 212.3 360.301 212 360.701 212.6C362.001 214.3 363.401 215.5 365.301 216.8C367.201 218.2 366.601 220.9 364.701 221.8C363.801 222.3 362.901 222.7 362.001 223.1C362.501 223.5 362.901 223.8 363.401 224.2C365.001 225.3 364.801 227.2 363.701 228.5C364.601 229.4 365.401 230.1 366.501 231.1C368.501 232.9 370.601 234.7 372.901 236.2C374.801 237.4 376.901 238.5 379.001 238.6C379.101 238.6 379.201 238.6 379.301 238.6C379.301 238.6 379.301 238.6 379.401 238.6C379.601 238.6 379.801 238.6 380.101 238.5C380.201 238.5 380.201 238.5 380.301 238.5H380.401C380.701 238.4 380.901 238.3 381.101 238.2C380.501 238.5 382.001 237.4 381.701 237.7C382.001 237.4 382.201 237.1 382.401 236.8V236.7C382.401 235.1 382.501 233.5 382.701 232C382.801 230.6 383.001 229.1 383.301 227.7C383.301 227.6 383.301 227.5 383.401 227.4C383.101 226.5 382.801 225.9 382.301 225.2C381.801 224.8 380.701 224 380.201 223.8Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M333.3 176.4C336 176.4 338.1 174.2 338.1 171.6C338.1 168.9 335.9 166.8 333.3 166.8C330.6 166.8 328.5 169 328.5 171.6C328.5 174.3 330.7 176.4 333.3 176.4Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M315.501 166.8C318.201 166.8 320.301 164.6 320.301 162C320.301 159.3 318.101 157.2 315.501 157.2C312.801 157.2 310.701 159.4 310.701 162C310.701 164.7 312.801 166.8 315.501 166.8Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M289.501 147.7C292.201 147.7 294.301 145.5 294.301 142.9C294.301 140.2 292.101 138.1 289.501 138.1C286.801 138.1 284.701 140.3 284.701 142.9C284.701 145.5 286.801 147.7 289.501 147.7Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138 237H401C401 309.625 342.125 369 269.5 369C196.875 369 138 309.625 138 237Z",
    fill: "#11154F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2996 79.4C29.2996 79.4 123.4 2.8 265.6 2.8C407.8 2.8 512.3 79.4 512.3 79.4L514.7 79.6C514.7 79.6 418.1 0 264.3 0C110.5 0 25.5996 80.9 25.5996 80.9L29.2996 79.4Z",
    fill: "url(#paint1_linear_6686_51309)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.1 225.6L29.2996 79.3999L25.5996 80.8999L121.1 225.6H124.1Z",
    fill: "url(#paint2_linear_6686_51309)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M417.4 225.6L512.3 79.3999L514.7 79.5999L420.4 225.6H417.4Z",
    fill: "url(#paint3_linear_6686_51309)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 224.4C188 217 354.1 216.1 436.4 224.4C460.3 226.8 530.7 234.5 530.7 234.5H0C0 234.5 78.8 226.8 105.6 224.4Z",
    fill: "url(#paint4_linear_6686_51309)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M530.7 234.5H0V240.8H530.7V234.5Z",
    fill: "#0B0F3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M530.7 234.9H0V234.2H530.7V234.9Z",
    fill: "url(#paint5_linear_6686_51309)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.4 305.7H297.6C294.5 305.7 292 303.2 292 300.1V255.5C292 252.4 294.5 249.9 297.6 249.9H375.4C378.5 249.9 381 252.4 381 255.5V300.1C380.9 303.2 378.4 305.7 375.4 305.7Z",
    fill: "#283D7E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M297.6 304.2C295.4 304.2 293.5 302.4 293.5 300.1V255.5C293.5 253.3 295.3 251.4 297.6 251.4H375.4C377.6 251.4 379.5 253.2 379.5 255.5V300.1C379.5 302.3 377.7 304.2 375.4 304.2H297.6Z",
    fill: "#0B0F3C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M297.6 303.2C295.9 303.2 294.5 301.8 294.5 300.1V255.5C294.5 253.8 295.9 252.4 297.6 252.4H375.4C377.1 252.4 378.5 253.8 378.5 255.5V300.1C378.5 301.8 377.1 303.2 375.4 303.2H297.6Z",
    fill: "#262757"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M301.1 257.8C301.1 257.1 301.7 256.6 302.3 256.6H309.8C310.5 256.6 311 257.2 311 257.8V265.3C311 266 310.4 266.5 309.8 266.5H302.3C301.6 266.5 301.1 265.9 301.1 265.3V257.8Z",
    fill: "#D8ECFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M306.699 258.5C306.799 258.5 306.999 258.6 306.999 258.7L307.999 261.3H309.199C309.399 261.3 309.499 261.4 309.499 261.6C309.499 261.8 309.399 261.9 309.199 261.9H307.799C307.699 261.9 307.599 261.8 307.499 261.7L306.799 259.9L305.699 264.4C305.699 264.5 305.599 264.6 305.399 264.6C305.299 264.6 305.099 264.5 305.099 264.4L304.099 261.8H302.999C302.799 261.8 302.699 261.7 302.699 261.5C302.699 261.3 302.799 261.2 302.999 261.2H304.399C304.499 261.2 304.599 261.3 304.699 261.4L305.399 263.2L306.499 258.7C306.499 258.6 306.599 258.5 306.699 258.5Z",
    fill: "#857BEE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.9 260.8C313.9 260.5 314.2 260.2 314.5 260.2H330.7C331 260.2 331.3 260.5 331.3 260.8V261.4C331.3 261.7 331 262 330.7 262H314.5C314.2 262 313.9 261.7 313.9 261.4V260.8Z",
    fill: "#F4B840"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M301.1 273.3C301.1 273 301.4 272.7 301.7 272.7H324C324.3 272.7 324.6 273 324.6 273.3V273.9C324.6 274.2 324.3 274.5 324 274.5H301.7C301.4 274.5 301.1 274.2 301.1 273.9V273.3Z",
    fill: "#EAF4FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M301.1 282C301.1 281.7 301.4 281.4 301.7 281.4H316.7C317 281.4 317.3 281.7 317.3 282V282.6C317.3 282.9 317 283.2 316.7 283.2H301.7C301.4 283.2 301.1 282.9 301.1 282.6V282Z",
    fill: "#EAF4FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M336.301 270.8C336.801 270.8 337.301 271 337.601 271.3C337.901 271.7 338.101 272.2 338.101 272.8C338.101 273.1 338.101 273.4 338.001 273.7C337.901 274 337.801 274.3 337.601 274.5C337.401 274.7 337.201 274.9 337.001 275.1C336.701 275.2 336.401 275.3 336.101 275.3C335.701 275.3 335.401 275.2 335.101 275V274.2C335.401 274.4 335.701 274.5 336.001 274.5C336.401 274.5 336.601 274.4 336.801 274.2C337.001 274 337.101 273.7 337.201 273.4C337.001 273.7 336.601 273.8 336.201 273.8C335.801 273.8 335.501 273.7 335.201 273.4C334.901 273.1 334.801 272.8 334.801 272.4C334.801 271.9 334.901 271.6 335.201 271.3C335.401 270.9 335.801 270.8 336.301 270.8ZM336.301 271.5C336.101 271.5 335.901 271.6 335.801 271.7C335.701 271.8 335.601 272 335.601 272.2C335.601 272.4 335.701 272.6 335.801 272.7C335.901 272.8 336.101 272.9 336.301 272.9C336.501 272.9 336.601 272.8 336.801 272.7C337.001 272.6 337.101 272.5 337.101 272.3C337.101 272 337.001 271.8 336.901 271.6C336.801 271.6 336.601 271.5 336.301 271.5Z",
    fill: "#FF6F37"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M341.301 272.9C341.501 273 341.701 273.1 341.901 273.3C342.101 273.5 342.101 273.7 342.101 274C342.101 274.4 341.901 274.7 341.601 275C341.301 275.2 340.901 275.4 340.401 275.4C339.901 275.4 339.501 275.3 339.201 275C338.901 274.8 338.701 274.4 338.701 274C338.701 273.8 338.801 273.5 338.901 273.3C339.001 273.1 339.201 273 339.501 272.9C339.301 272.8 339.201 272.7 339.001 272.5C338.901 272.3 338.801 272.2 338.801 272C338.801 271.6 338.901 271.4 339.201 271.1C339.501 270.9 339.901 270.8 340.301 270.8C340.701 270.8 341.101 270.9 341.401 271.1C341.701 271.3 341.801 271.6 341.801 272C341.801 272.2 341.701 272.4 341.601 272.5C341.601 272.7 341.501 272.8 341.301 272.9ZM339.701 272.1C339.701 272.3 339.801 272.4 339.901 272.5C340.001 272.6 340.201 272.6 340.401 272.6C340.601 272.6 340.801 272.5 340.901 272.5C341.001 272.4 341.101 272.3 341.101 272.1C341.101 271.9 341.001 271.8 340.901 271.7C340.801 271.6 340.601 271.5 340.401 271.5C340.201 271.5 340.001 271.6 339.901 271.7C339.701 271.8 339.701 271.9 339.701 272.1ZM341.201 273.9C341.201 273.7 341.101 273.6 341.001 273.4C340.801 273.3 340.701 273.2 340.401 273.2C340.101 273.2 340.001 273.3 339.801 273.4C339.601 273.5 339.601 273.7 339.601 273.9C339.601 274.1 339.701 274.2 339.801 274.3C340.001 274.4 340.201 274.5 340.401 274.5C340.601 274.5 340.801 274.4 341.001 274.3C341.101 274.2 341.201 274.1 341.201 273.9Z",
    fill: "#FF6F37"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M343.901 275.3C343.401 275.3 343.001 275.2 342.701 275V274.2C343.101 274.4 343.501 274.5 343.901 274.5C344.201 274.5 344.401 274.4 344.601 274.3C344.801 274.2 344.901 274 344.901 273.8C344.901 273.6 344.801 273.4 344.601 273.3C344.401 273.2 344.201 273.1 343.901 273.1C343.601 273.1 343.201 273.2 342.901 273.3L343.201 270.9H345.501V271.7H343.801L343.701 272.4C343.801 272.4 344.001 272.4 344.101 272.4C344.601 272.4 345.001 272.5 345.301 272.8C345.601 273.1 345.801 273.4 345.801 273.8C345.801 274.3 345.601 274.7 345.301 274.9C344.801 275.2 344.401 275.3 343.901 275.3Z",
    fill: "#FF6F37"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M349.202 275.2H348.302V274.1H346.102V273.5L348.302 270.9H349.202V273.5H349.802V274.2H349.202V275.2ZM348.302 272L347.102 273.4H348.302V272Z",
    fill: "#FF6F37"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M350.801 275.3C350.601 275.3 350.501 275.2 350.401 275.1C350.301 275 350.201 274.9 350.201 274.7C350.201 274.6 350.301 274.4 350.401 274.3C350.501 274.2 350.601 274.1 350.801 274.1C350.901 274.1 351.101 274.2 351.201 274.3C351.301 274.4 351.401 274.5 351.401 274.7C351.401 274.9 351.301 275 351.201 275.1C351.101 275.2 351.001 275.3 350.801 275.3Z",
    fill: "#FF6F37"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M354.802 275.3C354.302 275.3 353.902 275.2 353.602 275V274.2C354.002 274.4 354.402 274.5 354.802 274.5C355.102 274.5 355.302 274.4 355.502 274.3C355.702 274.2 355.802 274 355.802 273.8C355.802 273.6 355.702 273.4 355.502 273.3C355.302 273.2 355.102 273.1 354.802 273.1C354.502 273.1 354.102 273.2 353.802 273.3L354.102 270.9H356.402V271.7H354.702L354.602 272.4C354.702 272.4 354.902 272.4 355.002 272.4C355.502 272.4 355.902 272.5 356.202 272.8C356.502 273.1 356.702 273.4 356.702 273.8C356.702 274.3 356.502 274.7 356.202 274.9C355.702 275.2 355.302 275.3 354.802 275.3Z",
    fill: "#FF6F37"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M360.1 275.2H359.2V274.1H357V273.5L359.2 270.9H360.1V273.5H360.7V274.2H360.1V275.2ZM359.2 272L358 273.4H359.2V272Z",
    fill: "#FF6F37"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M362.3 275.2H361.3L363.1 271.6H361V270.8H364.1V271.5L362.3 275.2Z",
    fill: "#FF6F37"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M367.202 272.9C367.402 273 367.602 273.1 367.802 273.3C367.902 273.5 368.002 273.7 368.002 274C368.002 274.4 367.802 274.7 367.502 275C367.202 275.2 366.802 275.4 366.302 275.4C365.802 275.4 365.402 275.3 365.102 275C364.802 274.8 364.602 274.4 364.602 274C364.602 273.8 364.702 273.5 364.802 273.3C364.902 273.1 365.102 273 365.402 272.9C365.202 272.8 365.102 272.7 365.002 272.5C364.902 272.3 364.802 272.2 364.802 272C364.802 271.6 364.902 271.4 365.202 271.1C365.502 270.9 365.902 270.8 366.302 270.8C366.702 270.8 367.102 270.9 367.402 271.1C367.702 271.3 367.802 271.6 367.802 272C367.802 272.2 367.702 272.4 367.602 272.5C367.602 272.7 367.402 272.8 367.202 272.9ZM365.602 272.1C365.602 272.3 365.702 272.4 365.802 272.5C365.902 272.6 366.102 272.6 366.302 272.6C366.502 272.6 366.702 272.5 366.802 272.5C366.902 272.4 367.002 272.3 367.002 272.1C367.002 271.9 366.902 271.8 366.802 271.7C366.702 271.6 366.502 271.5 366.302 271.5C366.102 271.5 365.902 271.6 365.802 271.7C365.702 271.8 365.602 271.9 365.602 272.1ZM367.102 273.9C367.102 273.7 367.002 273.6 366.902 273.4C366.702 273.3 366.602 273.2 366.302 273.2C366.002 273.2 365.902 273.3 365.702 273.4C365.502 273.5 365.502 273.7 365.502 273.9C365.502 274.1 365.602 274.2 365.702 274.3C365.902 274.4 366.102 274.5 366.302 274.5C366.502 274.5 366.702 274.4 366.902 274.3C367.002 274.2 367.102 274.1 367.102 273.9Z",
    fill: "#FF6F37"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M370.201 270.8C370.801 270.8 371.201 271 371.501 271.3C371.801 271.7 372.001 272.2 372.001 272.8C372.001 273.1 372.001 273.4 371.901 273.7C371.801 274 371.701 274.3 371.501 274.5C371.301 274.7 371.101 274.9 370.901 275.1C370.601 275.2 370.301 275.3 370.001 275.3C369.601 275.3 369.301 275.2 369.001 275V274.2C369.301 274.4 369.601 274.5 369.901 274.5C370.301 274.5 370.501 274.4 370.701 274.2C370.901 274 371.001 273.7 371.101 273.4C370.901 273.7 370.501 273.8 370.101 273.8C369.701 273.8 369.401 273.7 369.101 273.4C368.801 273.1 368.701 272.8 368.701 272.4C368.701 271.9 368.801 271.6 369.101 271.3C369.401 270.9 369.701 270.8 370.201 270.8ZM370.201 271.5C370.001 271.5 369.801 271.6 369.701 271.7C369.601 271.8 369.501 272 369.501 272.2C369.501 272.4 369.601 272.6 369.701 272.7C369.801 272.8 370.001 272.9 370.201 272.9C370.401 272.9 370.501 272.8 370.701 272.7C370.901 272.6 371.001 272.5 371.001 272.3C371.001 272 370.901 271.8 370.801 271.6C370.701 271.6 370.501 271.5 370.201 271.5Z",
    fill: "#FF6F37"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M303.699 297.9C302.999 297.9 302.499 297.7 302.199 297.2C301.799 296.8 301.699 296.2 301.699 295.4C301.699 295 301.699 294.6 301.799 294.3C301.899 293.9 301.999 293.6 302.199 293.3C302.399 293 302.599 292.8 302.999 292.6C303.299 292.4 303.699 292.4 304.099 292.4C304.599 292.4 304.899 292.5 305.299 292.7V293.7C304.999 293.5 304.599 293.4 304.199 293.4C303.799 293.4 303.399 293.5 303.199 293.8C302.999 294.1 302.799 294.4 302.799 294.8C303.099 294.5 303.499 294.3 303.999 294.3C304.499 294.3 304.899 294.5 305.199 294.8C305.499 295.1 305.699 295.5 305.699 296C305.699 296.5 305.499 297 305.199 297.3C304.699 297.7 304.299 297.9 303.699 297.9ZM303.599 296.9C303.899 296.9 304.099 296.8 304.199 296.7C304.399 296.5 304.499 296.3 304.499 296C304.499 295.7 304.399 295.5 304.199 295.4C303.999 295.2 303.799 295.2 303.599 295.2C303.399 295.2 303.199 295.3 302.999 295.4C302.799 295.5 302.699 295.7 302.599 295.9C302.599 296.3 302.699 296.5 302.899 296.7C303.099 296.8 303.399 296.9 303.599 296.9Z",
    fill: "#569DD3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M307.799 297.9C307.299 297.9 306.799 297.8 306.299 297.5V296.5C306.699 296.8 307.199 296.9 307.699 296.9C307.999 296.9 308.299 296.8 308.499 296.7C308.699 296.5 308.799 296.3 308.799 296.1C308.799 295.8 308.699 295.6 308.499 295.5C308.299 295.3 307.999 295.3 307.699 295.3C307.299 295.3 306.899 295.4 306.399 295.5L306.699 292.6H309.499V293.5H307.499L307.399 294.4C307.599 294.4 307.699 294.3 307.899 294.3C308.499 294.3 308.999 294.5 309.299 294.8C309.699 295.1 309.899 295.5 309.899 296.1C309.899 296.7 309.699 297.1 309.299 297.5C308.999 297.7 308.399 297.9 307.799 297.9Z",
    fill: "#569DD3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M312.3 297.8H311.5L314.6 292.6H315.4L312.3 297.8ZM314 295.6C314.2 295.4 314.6 295.2 315 295.2C315.4 295.2 315.7 295.3 316 295.6C316.3 295.9 316.4 296.2 316.4 296.5C316.4 296.9 316.3 297.2 316 297.4C315.8 297.6 315.4 297.8 315 297.8C314.6 297.8 314.3 297.7 314 297.4C313.8 297.2 313.6 296.8 313.6 296.5C313.7 296.2 313.8 295.8 314 295.6ZM314.6 296.9C314.7 297 314.9 297.1 315 297.1C315.2 297.1 315.3 297 315.4 296.9C315.5 296.8 315.6 296.6 315.6 296.5C315.6 296.3 315.5 296.2 315.4 296.1C315.3 296 315.1 295.9 315 295.9C314.8 295.9 314.7 296 314.6 296.1C314.5 296.2 314.4 296.4 314.4 296.5C314.4 296.7 314.5 296.8 314.6 296.9ZM310.9 292.8C311.1 292.6 311.5 292.4 311.9 292.4C312.3 292.4 312.6 292.5 312.9 292.8C313.2 293 313.3 293.4 313.3 293.7C313.3 294.1 313.2 294.4 312.9 294.6C312.7 294.8 312.3 295 311.9 295C311.5 295 311.2 294.9 310.9 294.6C310.7 294.3 310.5 294 310.5 293.7C310.6 293.4 310.7 293.1 310.9 292.8ZM311.5 294.2C311.6 294.3 311.8 294.4 311.9 294.4C312.1 294.4 312.2 294.3 312.3 294.2C312.4 294.1 312.5 293.9 312.5 293.8C312.5 293.6 312.4 293.5 312.3 293.4C312.2 293.3 312 293.2 311.9 293.2C311.7 293.2 311.6 293.3 311.5 293.4C311.4 293.5 311.3 293.7 311.3 293.8C311.3 293.9 311.3 294.1 311.5 294.2Z",
    fill: "#569DD3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M337.5 261.1C337.7 261.2 337.9 261.3 338.1 261.5C338.2 261.7 338.3 261.9 338.3 262.2C338.3 262.6 338.1 262.9 337.8 263.2C337.5 263.4 337.1 263.6 336.6 263.6C336.1 263.6 335.7 263.5 335.4 263.2C335.1 262.9 334.9 262.6 334.9 262.2C334.9 262 335 261.7 335.1 261.5C335.2 261.3 335.4 261.2 335.7 261.1C335.5 261 335.4 260.9 335.2 260.7C335.1 260.5 335 260.4 335 260.2C335 259.8 335.1 259.6 335.4 259.3C335.7 259.1 336.1 259 336.5 259C336.9 259 337.3 259.1 337.6 259.3C337.9 259.5 338 259.8 338 260.2C338 260.4 337.9 260.6 337.8 260.7C337.9 260.9 337.7 261 337.5 261.1ZM335.9 260.3C335.9 260.5 336 260.6 336.1 260.7C336.2 260.8 336.4 260.8 336.6 260.8C336.8 260.8 337 260.8 337.1 260.7C337.2 260.6 337.3 260.5 337.3 260.3C337.3 260.1 337.2 260 337.1 259.9C337 259.8 336.8 259.7 336.6 259.7C336.4 259.7 336.2 259.8 336.1 259.9C336 260 335.9 260.1 335.9 260.3ZM337.4 262.1C337.4 261.9 337.3 261.8 337.2 261.6C337 261.5 336.9 261.4 336.6 261.4C336.3 261.4 336.2 261.5 336 261.6C335.8 261.7 335.8 261.9 335.8 262.1C335.8 262.3 335.9 262.4 336 262.5C336.2 262.6 336.4 262.7 336.6 262.7C336.8 262.7 337 262.6 337.2 262.5C337.3 262.5 337.4 262.3 337.4 262.1Z",
    fill: "#E6E6EB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M340.1 263.5C339.6 263.5 339.2 263.4 338.9 263.2V262.4C339.3 262.6 339.7 262.8 340.1 262.8C340.4 262.8 340.6 262.7 340.8 262.6C341 262.5 341.1 262.3 341.1 262.1C341.1 261.9 341 261.7 340.8 261.6C340.6 261.5 340.4 261.4 340.1 261.4C339.8 261.4 339.4 261.5 339.1 261.6L339.4 259.2H341.7V260H340L339.9 260.7C340 260.7 340.2 260.7 340.3 260.7C340.8 260.7 341.2 260.8 341.5 261.1C341.8 261.4 342 261.7 342 262.1C342 262.6 341.8 263 341.5 263.2C341.1 263.4 340.6 263.5 340.1 263.5Z",
    fill: "#E6E6EB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M344.3 263.5C343.8 263.5 343.3 263.3 343 263C342.7 262.6 342.5 262.1 342.5 261.5C342.5 261.2 342.5 260.9 342.6 260.6C342.7 260.3 342.8 260 343 259.8C343.2 259.6 343.4 259.4 343.6 259.2C343.9 259.1 344.2 259 344.5 259C344.9 259 345.2 259.1 345.5 259.3V260.1C345.2 259.9 344.9 259.8 344.6 259.8C344.2 259.8 344 259.9 343.8 260.1C343.6 260.3 343.5 260.6 343.5 260.9C343.7 260.6 344.1 260.5 344.5 260.5C344.9 260.5 345.2 260.6 345.5 260.9C345.8 261.2 345.9 261.5 345.9 261.9C345.9 262.4 345.7 262.7 345.4 263C345.2 263.4 344.8 263.5 344.3 263.5ZM344.3 262.7C344.5 262.7 344.7 262.6 344.8 262.5C344.9 262.4 345 262.2 345 262C345 261.8 344.9 261.6 344.8 261.5C344.7 261.4 344.5 261.3 344.3 261.3C344.1 261.3 344 261.4 343.8 261.5C343.7 261.6 343.5 261.7 343.5 261.9C343.5 262.2 343.6 262.4 343.7 262.6C343.8 262.7 344 262.7 344.3 262.7Z",
    fill: "#E6E6EB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M346.901 263.5C346.701 263.5 346.601 263.4 346.501 263.3C346.401 263.2 346.301 263.1 346.301 262.9C346.301 262.7 346.401 262.6 346.501 262.5C346.601 262.4 346.701 262.3 346.901 262.3C347.001 262.3 347.201 262.4 347.301 262.5C347.401 262.6 347.501 262.7 347.501 262.9C347.501 263.1 347.401 263.2 347.301 263.3C347.201 263.5 347.101 263.5 346.901 263.5Z",
    fill: "#E6E6EB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M349.501 263.5C349.001 263.5 348.601 263.4 348.301 263.2V262.4C348.701 262.6 349.101 262.8 349.501 262.8C349.801 262.8 350.001 262.7 350.201 262.6C350.401 262.5 350.501 262.3 350.501 262.1C350.501 261.9 350.401 261.7 350.201 261.6C350.001 261.5 349.801 261.4 349.501 261.4C349.201 261.4 348.801 261.5 348.501 261.6L348.801 259.2H351.101V260H349.401L349.301 260.7C349.401 260.7 349.601 260.7 349.701 260.7C350.201 260.7 350.601 260.8 350.901 261.1C351.201 261.4 351.401 261.7 351.401 262.1C351.401 262.6 351.201 263 350.901 263.2C350.401 263.4 350.001 263.5 349.501 263.5Z",
    fill: "#E6E6EB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M353.7 263.5C353.2 263.5 352.7 263.3 352.4 263C352.1 262.6 351.9 262.1 351.9 261.5C351.9 261.2 351.9 260.9 352 260.6C352.1 260.3 352.2 260 352.4 259.8C352.6 259.6 352.8 259.4 353 259.2C353.3 259.1 353.6 259 353.9 259C354.3 259 354.6 259.1 354.9 259.3V260.1C354.6 259.9 354.3 259.8 354 259.8C353.6 259.8 353.4 259.9 353.2 260.1C353 260.3 352.9 260.6 352.9 260.9C353.1 260.6 353.5 260.5 353.9 260.5C354.3 260.5 354.6 260.6 354.9 260.9C355.2 261.2 355.3 261.5 355.3 261.9C355.3 262.4 355.1 262.7 354.8 263C354.5 263.4 354.1 263.5 353.7 263.5ZM353.6 262.7C353.8 262.7 354 262.6 354.1 262.5C354.2 262.4 354.3 262.2 354.3 262C354.3 261.8 354.2 261.6 354.1 261.5C354 261.4 353.8 261.3 353.6 261.3C353.4 261.3 353.3 261.4 353.1 261.5C353 261.6 352.8 261.7 352.8 261.9C352.8 262.2 352.9 262.4 353 262.6C353.2 262.7 353.4 262.7 353.6 262.7Z",
    fill: "#E6E6EB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M358.5 261.1C358.7 261.2 358.9 261.3 359.1 261.5C359.2 261.7 359.3 261.9 359.3 262.2C359.3 262.6 359.1 262.9 358.8 263.2C358.5 263.4 358.1 263.6 357.6 263.6C357.1 263.6 356.7 263.5 356.4 263.2C356.1 263 355.9 262.6 355.9 262.2C355.9 262 356 261.7 356.1 261.5C356.2 261.3 356.4 261.2 356.7 261.1C356.5 261 356.4 260.9 356.3 260.7C356.2 260.5 356.1 260.4 356.1 260.2C356.1 259.8 356.2 259.6 356.5 259.3C356.8 259.1 357.2 259 357.6 259C358 259 358.4 259.1 358.7 259.3C359 259.5 359.1 259.8 359.1 260.2C359.1 260.4 359 260.6 358.9 260.7C358.8 260.9 358.7 261 358.5 261.1ZM356.9 260.3C356.9 260.5 357 260.6 357.1 260.7C357.2 260.8 357.4 260.8 357.6 260.8C357.8 260.8 358 260.8 358.1 260.7C358.2 260.6 358.3 260.5 358.3 260.3C358.3 260.1 358.2 260 358.1 259.9C358 259.8 357.8 259.7 357.6 259.7C357.4 259.7 357.2 259.8 357.1 259.9C356.9 260 356.9 260.1 356.9 260.3ZM358.4 262.1C358.4 261.9 358.3 261.8 358.2 261.6C358 261.5 357.9 261.4 357.6 261.4C357.3 261.4 357.2 261.5 357 261.6C356.8 261.7 356.8 261.9 356.8 262.1C356.8 262.3 356.9 262.4 357 262.5C357.2 262.6 357.4 262.7 357.6 262.7C357.8 262.7 358 262.6 358.2 262.5C358.3 262.5 358.4 262.3 358.4 262.1Z",
    fill: "#E6E6EB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M361.4 259C361.9 259 362.4 259.2 362.7 259.5C363 259.9 363.2 260.4 363.2 261C363.2 261.3 363.2 261.6 363.1 261.9C363 262.2 362.9 262.5 362.7 262.7C362.5 262.9 362.3 263.1 362.1 263.3C361.8 263.4 361.5 263.5 361.2 263.5C360.8 263.5 360.5 263.4 360.2 263.2V262.4C360.5 262.6 360.8 262.7 361.1 262.7C361.5 262.7 361.7 262.6 361.9 262.4C362.1 262.2 362.2 261.9 362.3 261.6C362.1 261.9 361.7 262 361.3 262C360.9 262 360.6 261.9 360.3 261.6C360 261.3 359.9 261 359.9 260.6C359.9 260.1 360 259.8 360.3 259.5C360.6 259.1 361 259 361.4 259ZM361.5 259.8C361.3 259.8 361.1 259.9 361 260C360.9 260.1 360.8 260.3 360.8 260.5C360.8 260.7 360.9 260.9 361 261C361.1 261.1 361.3 261.2 361.5 261.2C361.7 261.2 361.8 261.1 362 261C362.1 260.9 362.3 260.8 362.3 260.6C362.3 260.3 362.2 260.1 362.1 259.9C361.9 259.8 361.7 259.8 361.5 259.8Z",
    fill: "#E6E6EB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M364 263.5C363.8 263.5 363.7 263.4 363.6 263.3C363.5 263.2 363.4 263.1 363.4 262.9C363.4 262.7 363.5 262.6 363.6 262.5C363.7 262.4 363.8 262.3 364 262.3C364.2 262.3 364.3 262.4 364.4 262.5C364.5 262.6 364.6 262.7 364.6 262.9C364.6 263.1 364.5 263.2 364.4 263.3C364.3 263.5 364.2 263.5 364 263.5Z",
    fill: "#E6E6EB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M368.301 263.4H365.201V262.7L366.501 261.5C366.801 261.2 367.001 261 367.101 260.9C367.201 260.7 367.301 260.6 367.301 260.4C367.301 260.2 367.201 260.1 367.101 260C367.001 259.9 366.801 259.8 366.601 259.8C366.201 259.8 365.801 260 365.401 260.3V259.4C365.801 259.1 366.201 259 366.701 259C367.101 259 367.501 259.1 367.801 259.4C368.101 259.6 368.301 260 368.301 260.4C368.301 260.7 368.201 261 368.101 261.2C368.001 261.4 367.701 261.7 367.401 262L366.701 262.7H368.501V263.4H368.301Z",
    fill: "#E6E6EB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M370.2 263.5C369.7 263.5 369.2 263.4 368.9 263.1V262.2C369.3 262.5 369.7 262.6 370.2 262.6C370.5 262.6 370.7 262.5 370.9 262.4C371.1 262.3 371.2 262.1 371.2 261.9C371.2 261.7 371.1 261.5 371 261.4C370.8 261.3 370.6 261.2 370.4 261.2C370.2 261.2 370 261.2 369.8 261.3V260.7L370.8 259.7H369V258.9H371.8V259.6L370.8 260.5C371.1 260.6 371.4 260.7 371.6 260.9C371.8 261.1 372 261.4 372 261.8C372 262.3 371.8 262.6 371.5 262.9C371.1 263.4 370.7 263.5 370.2 263.5Z",
    fill: "#E6E6EB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M226.3 305.7H163.1C160 305.7 157.5 303.2 157.5 300.1V255.5C157.5 252.4 160 249.9 163.1 249.9H226.3C229.4 249.9 231.9 252.4 231.9 255.5V300.1C231.9 303.2 229.4 305.7 226.3 305.7Z",
    fill: "#283D7E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M163.1 304.2C160.9 304.2 159 302.4 159 300.1V255.5C159 253.3 160.8 251.4 163.1 251.4H226.3C228.5 251.4 230.4 253.2 230.4 255.5V300.1C230.4 302.3 228.6 304.2 226.3 304.2H163.1Z",
    fill: "#0B0F3C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M163.1 303.2C161.4 303.2 160 301.8 160 300.1V255.5C160 253.8 161.4 252.4 163.1 252.4H226.3C228 252.4 229.4 253.8 229.4 255.5V300.1C229.4 301.8 228 303.2 226.3 303.2H163.1Z",
    fill: "#262757"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M218.9 279.5C218.6 281.3 218.1 282.9 217.3 284.1C216.5 285.3 215.9 286.2 215.2 286.8C214.5 287.4 213.7 287.8 212.6 287.8C211.5 287.8 210.1 287.5 208.2 286.9C206.3 286.3 203.8 285.4 200.4 284.2C193.8 281.8 190.2 282 187.2 284.1C185.7 285.1 184.3 286.7 182.8 288.7C182 289.7 181.2 290.9 180.3 292.1C179.5 293.3 178.6 294.6 177.5 295.9L177 295.5C178 294.1 178.9 292.9 179.7 291.7C180.6 290.4 181.4 289.3 182.2 288.2C183.7 286.2 185.1 284.6 186.7 283.5C189.9 281.3 193.7 281.2 200.5 283.5C203.8 284.7 206.3 285.6 208.3 286.2C210.2 286.8 211.5 287.1 212.5 287.1C213.5 287.1 214.1 286.8 214.7 286.3C215.3 285.7 215.9 284.9 216.7 283.7C217.5 282.6 217.9 281.1 218.2 279.3C218.3 278.6 218.4 277.9 218.6 277.2C218.8 276 219 274.8 219.2 273.7C220.1 269.8 221.7 266 226.6 264L226.8 264.6C222.2 266.5 220.6 270.1 219.8 273.8C219.5 275 219.4 276.1 219.2 277.3C219.2 278.1 219.1 278.8 218.9 279.5Z",
    fill: "#FF6F37"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M195.701 282.6C195.701 283.3 195.201 283.8 194.501 283.8C193.801 283.8 193.301 283.3 193.301 282.6C193.301 281.9 193.801 281.4 194.501 281.4C195.101 281.3 195.701 281.9 195.701 282.6Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M223.8 267.1C223.8 267.8 223.3 268.3 222.6 268.3C221.9 268.3 221.4 267.8 221.4 267.1C221.4 266.4 221.9 265.9 222.6 265.9C223.2 265.9 223.8 266.4 223.8 267.1Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 260.3C164.5 260 164.8 259.7 165.1 259.7H183.5C183.8 259.7 184.1 260 184.1 260.3V260.9C184.1 261.2 183.8 261.5 183.5 261.5H165.1C164.8 261.5 164.5 261.2 164.5 260.9V260.3Z",
    fill: "#EA6B3D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M199.1 269.8H198.5V268.8H197.6V268.2H198.5V267.2H199.1V268.2H200.1V268.8H199.1V269.8Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M203.5 270.8H202.9V270.3C202.5 270.3 202.2 270.1 201.9 269.9V269.2C202 269.3 202.2 269.4 202.5 269.5C202.7 269.6 203 269.6 203.2 269.6C203.4 269.6 203.6 269.6 203.7 269.5C203.8 269.4 203.9 269.3 203.9 269.2C203.9 269.1 203.8 269 203.7 268.9C203.6 268.9 203.6 268.8 203.5 268.8H203.4L203.1 268.7L202.8 268.6C202.8 268.6 202.7 268.6 202.6 268.5C202.5 268.5 202.4 268.4 202.4 268.4C202.2 268.3 202.1 268.2 202.1 268.1C202 267.9 202 267.8 202 267.6C202 267.3 202.1 267.1 202.3 267C202.5 266.8 202.7 266.7 203 266.7V266.2H203.6V266.7C203.9 266.7 204.1 266.8 204.4 267V267.7C204 267.5 203.7 267.4 203.3 267.4C202.9 267.4 202.7 267.5 202.7 267.7C202.7 267.8 202.8 267.9 202.9 267.9C203 267.9 203.1 268 203.2 268C203.4 268 203.5 268.1 203.6 268.1C203.9 268.2 204.1 268.3 204.4 268.5C204.6 268.7 204.8 268.9 204.8 269.2C204.8 269.5 204.7 269.7 204.5 269.9C204.3 270.1 204.1 270.2 203.7 270.3V270.8H203.5Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M207.1 268.4C207.3 268.5 207.5 268.6 207.6 268.7C207.7 268.9 207.8 269 207.8 269.2C207.8 269.5 207.7 269.8 207.4 270C207.1 270.2 206.8 270.3 206.4 270.3C206 270.3 205.7 270.2 205.4 270C205.1 269.8 205 269.6 205 269.2C205 269 205.1 268.8 205.2 268.7C205.3 268.5 205.5 268.4 205.7 268.4C205.5 268.3 205.4 268.2 205.3 268.1C205.2 268 205.2 267.8 205.2 267.7C205.2 267.4 205.3 267.2 205.5 267C205.7 266.8 206 266.7 206.4 266.7C206.7 266.7 207 266.8 207.3 267C207.5 267.2 207.7 267.4 207.7 267.7C207.7 267.9 207.7 268 207.6 268.1C207.4 268.2 207.3 268.3 207.1 268.4ZM205.9 267.7C205.9 267.8 206 267.9 206.1 268C206.2 268.1 206.3 268.1 206.5 268.1C206.7 268.1 206.8 268.1 206.9 268C207 267.9 207.1 267.8 207.1 267.7C207.1 267.6 207 267.5 206.9 267.4C206.8 267.3 206.7 267.3 206.5 267.3C206.3 267.3 206.2 267.3 206.1 267.4C205.9 267.5 205.9 267.6 205.9 267.7ZM207.1 269.2C207.1 269.1 207 268.9 206.9 268.8C206.8 268.7 206.6 268.7 206.4 268.7C206.2 268.7 206.1 268.7 205.9 268.8C205.8 268.9 205.7 269 205.7 269.2C205.7 269.3 205.8 269.5 205.9 269.6C206 269.7 206.2 269.7 206.4 269.7C206.6 269.7 206.7 269.7 206.9 269.6C207 269.4 207.1 269.3 207.1 269.2Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M209.2 270.2H208.4L209.8 267.3H208.1V266.7H210.6V267.3L209.2 270.2Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3 266.6C212.7 266.6 213.1 266.7 213.3 267C213.5 267.3 213.7 267.7 213.7 268.2C213.7 268.5 213.7 268.7 213.6 268.9C213.5 269.1 213.4 269.3 213.3 269.5C213.2 269.7 213 269.8 212.8 269.9C212.6 270 212.4 270.1 212.1 270.1C211.8 270.1 211.5 270 211.3 269.9V269.2C211.5 269.4 211.8 269.4 212 269.4C212.3 269.4 212.5 269.3 212.7 269.1C212.9 268.9 213 268.7 213 268.4C212.8 268.6 212.5 268.7 212.2 268.7C211.9 268.7 211.6 268.6 211.4 268.4C211.2 268.2 211.1 267.9 211.1 267.6C211.1 267.2 211.2 266.9 211.5 266.7C211.6 266.8 211.9 266.6 212.3 266.6ZM212.3 267.3C212.1 267.3 212 267.4 211.9 267.5C211.8 267.6 211.7 267.8 211.7 267.9C211.7 268.1 211.8 268.2 211.9 268.3C212 268.4 212.2 268.5 212.3 268.5C212.4 268.5 212.6 268.5 212.7 268.4C212.8 268.3 212.9 268.2 213 268.1C213 267.9 212.9 267.7 212.8 267.6C212.7 267.3 212.5 267.3 212.3 267.3Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M215.599 270.3C215.199 270.3 214.799 270.2 214.599 269.9C214.399 269.6 214.199 269.2 214.199 268.7C214.199 268.4 214.199 268.2 214.299 268C214.399 267.8 214.499 267.6 214.599 267.4C214.699 267.2 214.899 267.1 215.099 267C215.299 266.9 215.499 266.8 215.799 266.8C216.099 266.8 216.399 266.9 216.599 267V267.6C216.399 267.5 216.099 267.4 215.899 267.4C215.599 267.4 215.399 267.5 215.199 267.7C214.999 267.9 214.899 268.1 214.899 268.4C215.099 268.2 215.399 268.1 215.699 268.1C215.999 268.1 216.299 268.2 216.499 268.4C216.699 268.6 216.799 268.9 216.799 269.2C216.799 269.6 216.699 269.9 216.399 270.1C216.299 270.2 215.999 270.3 215.599 270.3ZM215.599 269.7C215.799 269.7 215.899 269.6 215.999 269.5C216.099 269.4 216.199 269.2 216.199 269.1C216.199 268.9 216.099 268.8 215.999 268.7C215.899 268.6 215.699 268.5 215.599 268.5C215.499 268.5 215.299 268.5 215.199 268.6C215.099 268.7 214.999 268.8 214.899 268.9C214.899 269.1 214.999 269.3 215.099 269.4C215.199 269.6 215.399 269.7 215.599 269.7Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M166.8 273.299H165.7V269.2L164.6 269.799V268.7L165.8 268H166.7V273.299H166.8Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M169.7 273.299H168.6V269.2L167.5 269.799V268.7L168.7 268H169.6V273.299H169.7Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M172.9 273.4C172.4 273.4 172 273.3 171.7 273C171.4 272.7 171.1 272.4 170.9 272C170.7 271.6 170.6 271.1 170.6 270.7C170.6 270.2 170.7 269.8 170.9 269.4C171.1 269 171.3 268.6 171.7 268.4C172.1 268.1 172.5 268 172.9 268C173.6 268 174.1 268.299 174.5 268.799C174.9 269.299 175.1 270 175.1 270.7C175.1 271.4 174.9 272.1 174.5 272.6C174.2 273.2 173.6 273.4 172.9 273.4ZM172.1 271.9C172.3 272.2 172.6 272.4 173 272.4C173.4 272.4 173.6 272.2 173.9 271.9C174.1 271.6 174.2 271.2 174.2 270.7C174.2 270.2 174.1 269.8 173.9 269.5C173.7 269.2 173.4 269 173 269C172.6 269 172.4 269.2 172.1 269.5C171.9 269.8 171.8 270.2 171.8 270.7C171.8 271.2 171.9 271.6 172.1 271.9Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M177.301 273.299H176.201L178.301 269H175.801V268H179.501V268.799L177.301 273.299Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 273.4C180.9 273.4 180.5 273.3 180 273V272C180.4 272.3 180.9 272.4 181.4 272.4C181.7 272.4 182 272.3 182.2 272.2C182.4 272 182.5 271.8 182.5 271.6C182.5 271.3 182.4 271.1 182.2 271C182 270.8 181.7 270.8 181.4 270.8C181 270.8 180.6 270.9 180.1 271L180.4 268.1H183.2V269H181.2L181.1 269.9C181.3 269.9 181.4 269.8 181.6 269.8C182.2 269.8 182.7 270 183 270.3C183.4 270.6 183.6 271 183.6 271.6C183.6 272.2 183.4 272.6 183 273C182.7 273.3 182.1 273.4 181.5 273.4Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M187.6 270.5C187.9 270.6 188.1 270.8 188.3 271C188.5 271.2 188.6 271.5 188.6 271.8C188.6 272.3 188.4 272.7 188 273C187.6 273.3 187.1 273.4 186.5 273.4C185.9 273.4 185.4 273.3 185 273C184.6 272.7 184.4 272.3 184.4 271.8C184.4 271.5 184.5 271.2 184.7 271C184.9 270.8 185.1 270.6 185.4 270.5C185.2 270.4 185 270.2 184.9 270C184.8 269.8 184.7 269.6 184.7 269.3C184.7 268.9 184.9 268.5 185.2 268.3C185.6 268 186 267.9 186.5 267.9C187 267.9 187.5 268 187.8 268.3C188.2 268.6 188.3 268.9 188.3 269.3C188.3 269.5 188.2 269.8 188.1 270C188 270.3 187.8 270.4 187.6 270.5ZM185.7 269.5C185.7 269.7 185.8 269.8 185.9 270C186.1 270.1 186.3 270.2 186.5 270.2C186.7 270.2 186.9 270.1 187.1 270C187.3 269.9 187.3 269.7 187.3 269.5C187.3 269.3 187.2 269.1 187.1 269C186.9 268.9 186.8 268.8 186.5 268.8C186.3 268.8 186.1 268.9 185.9 269C185.7 269.2 185.7 269.4 185.7 269.5ZM187.4 271.8C187.4 271.6 187.3 271.4 187.1 271.3C186.9 271.2 186.7 271.1 186.4 271.1C186.1 271.1 185.9 271.2 185.7 271.3C185.5 271.4 185.4 271.6 185.4 271.8C185.4 272 185.5 272.2 185.7 272.3C185.9 272.4 186.1 272.5 186.4 272.5C186.7 272.5 186.9 272.4 187.1 272.3C187.4 272.2 187.4 272 187.4 271.8Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M172.999 282.2H172.599V281.299H171.699V280.9H172.599V280H172.999V280.9H173.899V281.299H172.999V282.2Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M175.501 282.6H175.001V280L174.301 280.4V279.9L175.001 279.5H175.401V282.6H175.501Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M177.399 282.6C176.999 282.6 176.699 282.4 176.499 282.1C176.299 281.8 176.199 281.4 176.199 281C176.199 280.6 176.299 280.2 176.499 279.9C176.699 279.6 176.999 279.4 177.399 279.4C177.799 279.4 178.099 279.6 178.299 279.9C178.499 280.2 178.699 280.6 178.699 281C178.699 281.4 178.599 281.8 178.299 282.1C178.099 282.5 177.799 282.6 177.399 282.6ZM177.399 282.2C177.599 282.2 177.799 282.1 177.999 281.9C178.099 281.7 178.199 281.4 178.199 281.1C178.199 280.8 178.099 280.5 177.999 280.3C177.899 280.1 177.699 280 177.399 280C177.199 280 176.999 280.1 176.799 280.3C176.699 280.5 176.599 280.8 176.599 281.1C176.599 281.4 176.699 281.7 176.799 281.9C176.999 282.1 177.199 282.2 177.399 282.2Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M180.099 282.6C179.799 282.6 179.499 282.5 179.199 282.4V282C179.499 282.2 179.699 282.2 179.999 282.2C180.199 282.2 180.399 282.1 180.599 282C180.799 281.9 180.799 281.7 180.799 281.5C180.799 281.3 180.699 281.2 180.599 281.1C180.499 281 180.299 280.9 179.999 280.9C179.799 280.9 179.499 280.9 179.299 281L179.499 279.4H181.099V279.8H179.899L179.799 280.5C179.899 280.5 179.999 280.5 180.199 280.5C180.499 280.5 180.799 280.6 180.999 280.8C181.199 281 181.299 281.2 181.299 281.5C181.299 281.8 181.199 282.1 180.899 282.3C180.699 282.6 180.399 282.6 180.099 282.6Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M166 279.8L167.3 282.1H164.6L166 279.8Z",
    fill: "#EA6B3D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M402.1 320.8C403.812 320.8 405.2 320.397 405.2 319.9C405.2 319.403 403.812 319 402.1 319C400.388 319 399 319.403 399 319.9C399 320.397 400.388 320.8 402.1 320.8Z",
    fill: "url(#paint6_linear_6686_51309)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M393.1 320.8C394.812 320.8 396.2 320.397 396.2 319.9C396.2 319.403 394.812 319 393.1 319C391.388 319 390 319.403 390 319.9C390 320.397 391.388 320.8 393.1 320.8Z",
    fill: "url(#paint7_linear_6686_51309)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M384.299 320.8C386.011 320.8 387.399 320.397 387.399 319.9C387.399 319.403 386.011 319 384.299 319C382.587 319 381.199 319.403 381.199 319.9C381.199 320.397 382.587 320.8 384.299 320.8Z",
    fill: "url(#paint8_linear_6686_51309)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M389.5 324.2C391.212 324.2 392.6 323.797 392.6 323.3C392.6 322.803 391.212 322.4 389.5 322.4C387.788 322.4 386.4 322.803 386.4 323.3C386.4 323.797 387.788 324.2 389.5 324.2Z",
    fill: "url(#paint9_linear_6686_51309)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M398.899 324.2C400.611 324.2 401.999 323.797 401.999 323.3C401.999 322.803 400.611 322.4 398.899 322.4C397.187 322.4 395.799 322.803 395.799 323.3C395.799 323.797 397.187 324.2 398.899 324.2Z",
    fill: "#262757"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M408.2 324.2C409.912 324.2 411.3 323.797 411.3 323.3C411.3 322.803 409.912 322.4 408.2 322.4C406.488 322.4 405.1 322.803 405.1 323.3C405.1 323.797 406.488 324.2 408.2 324.2Z",
    fill: "url(#paint10_linear_6686_51309)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M393.5 327.6C395.212 327.6 396.6 327.197 396.6 326.7C396.6 326.203 395.212 325.8 393.5 325.8C391.788 325.8 390.4 326.203 390.4 326.7C390.4 327.197 391.788 327.6 393.5 327.6Z",
    fill: "url(#paint11_linear_6686_51309)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M374.2 320.8C375.912 320.8 377.3 320.397 377.3 319.9C377.3 319.403 375.912 319 374.2 319C372.488 319 371.1 319.403 371.1 319.9C371.1 320.397 372.488 320.8 374.2 320.8Z",
    fill: "url(#paint12_linear_6686_51309)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M379.399 324.2C381.111 324.2 382.499 323.797 382.499 323.3C382.499 322.803 381.111 322.4 379.399 322.4C377.687 322.4 376.299 322.803 376.299 323.3C376.299 323.797 377.687 324.2 379.399 324.2Z",
    fill: "url(#paint13_linear_6686_51309)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M383.299 327.6C385.011 327.6 386.399 327.197 386.399 326.7C386.399 326.203 385.011 325.8 383.299 325.8C381.587 325.8 380.199 326.203 380.199 326.7C380.199 327.197 381.587 327.6 383.299 327.6Z",
    fill: "url(#paint14_linear_6686_51309)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M364.2 320.8C365.912 320.8 367.3 320.397 367.3 319.9C367.3 319.403 365.912 319 364.2 319C362.488 319 361.1 319.403 361.1 319.9C361.1 320.397 362.488 320.8 364.2 320.8Z",
    fill: "url(#paint15_linear_6686_51309)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M369.399 324.2C371.111 324.2 372.499 323.797 372.499 323.3C372.499 322.803 371.111 322.4 369.399 322.4C367.687 322.4 366.299 322.803 366.299 323.3C366.299 323.797 367.687 324.2 369.399 324.2Z",
    fill: "url(#paint16_linear_6686_51309)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M373.299 327.6C375.011 327.6 376.399 327.197 376.399 326.7C376.399 326.203 375.011 325.8 373.299 325.8C371.587 325.8 370.199 326.203 370.199 326.7C370.199 327.197 371.587 327.6 373.299 327.6Z",
    fill: "url(#paint17_linear_6686_51309)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M404.1 327.6C405.812 327.6 407.2 327.197 407.2 326.7C407.2 326.203 405.812 325.8 404.1 325.8C402.388 325.8 401 326.203 401 326.7C401 327.197 402.388 327.6 404.1 327.6Z",
    fill: "#262757"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M414.1 327.6C415.812 327.6 417.2 327.197 417.2 326.7C417.2 326.203 415.812 325.8 414.1 325.8C412.388 325.8 411 326.203 411 326.7C411 327.197 412.388 327.6 414.1 327.6Z",
    fill: "#262757"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M398.299 331.2C400.011 331.2 401.399 330.797 401.399 330.3C401.399 329.803 400.011 329.4 398.299 329.4C396.587 329.4 395.199 329.803 395.199 330.3C395.199 330.797 396.587 331.2 398.299 331.2Z",
    fill: "url(#paint18_linear_6686_51309)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M388.1 331.2C389.812 331.2 391.2 330.797 391.2 330.3C391.2 329.803 389.812 329.4 388.1 329.4C386.388 329.4 385 329.803 385 330.3C385 330.797 386.388 331.2 388.1 331.2Z",
    fill: "url(#paint19_linear_6686_51309)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M378.1 331.2C379.812 331.2 381.2 330.797 381.2 330.3C381.2 329.803 379.812 329.4 378.1 329.4C376.388 329.4 375 329.803 375 330.3C375 330.797 376.388 331.2 378.1 331.2Z",
    fill: "url(#paint20_linear_6686_51309)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M409.1 331.2C410.812 331.2 412.2 330.797 412.2 330.3C412.2 329.803 410.812 329.4 409.1 329.4C407.388 329.4 406 329.803 406 330.3C406 330.797 407.388 331.2 409.1 331.2Z",
    fill: "#262757"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M419.5 331.2C421.212 331.2 422.6 330.797 422.6 330.3C422.6 329.803 421.212 329.4 419.5 329.4C417.788 329.4 416.4 329.803 416.4 330.3C416.4 330.797 417.788 331.2 419.5 331.2Z",
    fill: "#262757"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M403.2 334.8C404.912 334.8 406.3 334.397 406.3 333.9C406.3 333.403 404.912 333 403.2 333C401.488 333 400.1 333.403 400.1 333.9C400.1 334.397 401.488 334.8 403.2 334.8Z",
    fill: "url(#paint21_linear_6686_51309)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M414.2 334.8C415.912 334.8 417.3 334.397 417.3 333.9C417.3 333.403 415.912 333 414.2 333C412.488 333 411.1 333.403 411.1 333.9C411.1 334.397 412.488 334.8 414.2 334.8Z",
    fill: "#262757"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M425.2 334.8C426.912 334.8 428.3 334.397 428.3 333.9C428.3 333.403 426.912 333 425.2 333C423.488 333 422.1 333.403 422.1 333.9C422.1 334.397 423.488 334.8 425.2 334.8Z",
    fill: "#262757"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M382.399 335.6H396.199C396.899 335.6 397.199 334.8 396.599 334.3L395.799 333.6C395.299 333.2 394.699 332.9 394.099 332.9H380.599C379.899 332.9 379.499 333.7 379.999 334.2L380.699 334.9C381.199 335.4 381.799 335.6 382.399 335.6Z",
    fill: "url(#paint22_linear_6686_51309)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M413.4 346.3L412.6 345.7C427.7 327.3 412.2 313.1 412.1 312.9L412.8 312.2C413 312.2 429.2 327.1 413.4 346.3Z",
    fill: "#515E88"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M376.801 353.9C370.201 328.3 379.701 325.4 380.101 325.2L380.401 326.2C380.301 326.2 371.501 329.1 377.801 353.6L376.801 353.9Z",
    fill: "#515E88"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M241.4 252.9C239 252.9 237 254.8 237 257.2V301.7C237 304.1 239 306 241.4 306H282.3C284.7 306 286.7 304.1 286.7 301.7V257.2C286.7 254.8 284.7 252.9 282.3 252.9H241.4Z",
    fill: "#0B0F3C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M268.2 280.8C265.8 280.8 263.9 282.8 263.9 285.3V294.7C263.9 297.2 265.8 299.2 268.2 299.2H277.8C280.2 299.2 282.1 297.2 282.1 294.7V285.3C282.1 282.8 280.2 280.8 277.8 280.8H268.2Z",
    fill: "#262757"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M270 270.3C270 271.7 268.9 272.8 267.5 272.8C266.1 272.8 265 271.7 265 270.3C265 268.9 266.1 267.8 267.5 267.8C268.9 267.8 270 268.9 270 270.3Z",
    fill: "url(#paint23_linear_6686_51309)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M268.5 270.3C268.5 270.9 268.1 271.3 267.5 271.3C266.9 271.3 266.5 270.9 266.5 270.3C266.5 269.7 266.9 269.3 267.5 269.3C268 269.3 268.5 269.7 268.5 270.3Z",
    fill: "#121B2E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M247 270.3C247 271.7 245.9 272.8 244.5 272.8C243.1 272.8 242 271.7 242 270.3C242 268.9 243.1 267.8 244.5 267.8C245.9 267.8 247 268.9 247 270.3Z",
    fill: "url(#paint24_linear_6686_51309)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 270.3C245.5 270.9 245.1 271.3 244.5 271.3C243.9 271.3 243.5 270.9 243.5 270.3C243.5 269.7 243.9 269.3 244.5 269.3C245 269.3 245.5 269.7 245.5 270.3Z",
    fill: "#121B2E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5 270.3C258.5 271.7 257.4 272.8 256 272.8C254.6 272.8 253.5 271.7 253.5 270.3C253.5 268.9 254.6 267.8 256 267.8C257.4 267.8 258.5 268.9 258.5 270.3Z",
    fill: "url(#paint25_linear_6686_51309)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M257 270.3C257 270.9 256.6 271.3 256 271.3C255.4 271.3 255 270.9 255 270.3C255 269.7 255.4 269.3 256 269.3C256.5 269.3 257 269.7 257 270.3Z",
    fill: "#121B2E"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M281.5 270.3C281.5 271.7 280.4 272.8 279 272.8C277.6 272.8 276.5 271.7 276.5 270.3C276.5 268.9 277.6 267.8 279 267.8C280.4 267.8 281.5 268.9 281.5 270.3Z",
    fill: "url(#paint26_linear_6686_51309)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M280 270.3C280 270.9 279.6 271.3 279 271.3C278.4 271.3 278 270.9 278 270.3C278 269.7 278.4 269.3 279 269.3C279.6 269.3 280 269.7 280 270.3Z",
    fill: "#121B2E"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M270 261C270 262.4 268.9 263.5 267.5 263.5C266.1 263.5 265 262.4 265 261C265 259.6 266.1 258.5 267.5 258.5C268.9 258.5 270 259.7 270 261Z",
    fill: "url(#paint27_linear_6686_51309)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M268.5 261C268.5 261.6 268.1 262 267.5 262C266.9 262 266.5 261.6 266.5 261C266.5 260.4 266.9 260 267.5 260C268 260 268.5 260.5 268.5 261Z",
    fill: "#121B2E"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M247 261C247 262.4 245.9 263.5 244.5 263.5C243.1 263.5 242 262.4 242 261C242 259.6 243.1 258.5 244.5 258.5C245.9 258.6 247 259.7 247 261Z",
    fill: "url(#paint28_linear_6686_51309)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M245.5 261C245.5 261.6 245.1 262 244.5 262C243.9 262 243.5 261.6 243.5 261C243.5 260.4 243.9 260 244.5 260C245 260 245.5 260.5 245.5 261Z",
    fill: "#121B2E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5 261C258.5 262.4 257.4 263.5 256 263.5C254.6 263.5 253.5 262.4 253.5 261C253.5 259.6 254.6 258.5 256 258.5C257.4 258.6 258.5 259.7 258.5 261Z",
    fill: "url(#paint29_linear_6686_51309)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M257 261C257 261.6 256.6 262 256 262C255.4 262 255 261.6 255 261C255 260.4 255.4 260 256 260C256.5 260 257 260.5 257 261Z",
    fill: "#121B2E"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M281.5 261C281.5 262.4 280.4 263.5 279 263.5C277.6 263.5 276.5 262.4 276.5 261C276.5 259.6 277.6 258.5 279 258.5C280.4 258.5 281.5 259.7 281.5 261Z",
    fill: "url(#paint30_linear_6686_51309)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M280 261C280 261.6 279.6 262 279 262C278.4 262 278 261.6 278 261C278 260.4 278.4 260 279 260C279.6 260 280 260.5 280 261Z",
    fill: "#121B2E"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M270.001 285.6C270.001 286.2 269.501 286.7 268.901 286.7C268.301 286.7 267.801 286.2 267.801 285.6C267.801 285 268.301 284.5 268.901 284.5C269.501 284.5 270.001 285 270.001 285.6Z",
    fill: "#0B0F3C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M274.1 285.6C274.1 286.2 273.6 286.7 273 286.7C272.4 286.7 271.9 286.2 271.9 285.6C271.9 285 272.4 284.5 273 284.5C273.6 284.5 274.1 285 274.1 285.6Z",
    fill: "#0B0F3C"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M278.1 285.6C278.1 286.2 277.6 286.7 277 286.7C276.4 286.7 275.9 286.2 275.9 285.6C275.9 285 276.4 284.5 277 284.5C277.6 284.5 278.1 285 278.1 285.6Z",
    fill: "#0B0F3C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M270.001 289.7C270.001 290.3 269.501 290.8 268.901 290.8C268.301 290.8 267.801 290.3 267.801 289.7C267.801 289.1 268.301 288.6 268.901 288.6C269.501 288.6 270.001 289.1 270.001 289.7Z",
    fill: "#0B0F3C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M270.001 293.7C270.001 294.3 269.501 294.8 268.901 294.8C268.301 294.8 267.801 294.3 267.801 293.7C267.801 293.1 268.301 292.6 268.901 292.6C269.501 292.7 270.001 293.1 270.001 293.7Z",
    fill: "#0B0F3C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M274.1 293.7C274.1 294.3 273.6 294.8 273 294.8C272.4 294.8 271.9 294.3 271.9 293.7C271.9 293.1 272.4 292.6 273 292.6C273.6 292.7 274.1 293.1 274.1 293.7Z",
    fill: "#0B0F3C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M274.1 289.7C274.1 290.3 273.6 290.8 273 290.8C272.4 290.8 271.9 290.3 271.9 289.7C271.9 289.1 272.4 288.6 273 288.6C273.6 288.6 274.1 289.1 274.1 289.7Z",
    fill: "#0B0F3C"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M278.1 289.7C278.1 290.3 277.6 290.8 277 290.8C276.4 290.8 275.9 290.3 275.9 289.7C275.9 289.1 276.4 288.6 277 288.6C277.6 288.6 278.1 289.1 278.1 289.7Z",
    fill: "#0B0F3C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M278.1 293.7C278.1 294.3 277.6 294.8 277 294.8C276.4 294.8 275.9 294.3 275.9 293.7C275.9 293.1 276.4 292.6 277 292.6C277.6 292.7 278.1 293.1 278.1 293.7Z",
    fill: "#0B0F3C"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M244.499 300.8H244.199C243.099 300.8 242.199 299.9 242.199 298.8V278.3C242.199 277.2 243.099 276.3 244.199 276.3H244.499C245.599 276.3 246.499 277.2 246.499 278.3V298.8C246.499 299.9 245.599 300.8 244.499 300.8Z",
    fill: "url(#paint31_linear_6686_51309)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M256.2 300.8H255.9C254.8 300.8 253.9 299.9 253.9 298.8V278.3C253.9 277.2 254.8 276.3 255.9 276.3H256.2C257.3 276.3 258.2 277.2 258.2 278.3V298.8C258.2 299.9 257.3 300.8 256.2 300.8Z",
    fill: "url(#paint32_linear_6686_51309)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M258.4 290.3C258.4 291.6 257.3 292.7 256 292.7C254.7 292.7 253.6 291.6 253.6 290.3C253.6 289 254.7 287.9 256 287.9C257.3 288 258.4 289 258.4 290.3Z",
    fill: "url(#paint33_linear_6686_51309)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M256.9 290.3C256.9 290.8 256.5 291.3 255.9 291.3C255.3 291.3 254.9 290.9 254.9 290.3C254.9 289.8 255.3 289.3 255.9 289.3C256.5 289.3 256.9 289.8 256.9 290.3Z",
    fill: "#121B2E"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M246.7 285.1C246.7 286.4 245.6 287.5 244.3 287.5C243 287.5 241.9 286.4 241.9 285.1C241.9 283.8 243 282.7 244.3 282.7C245.7 282.7 246.7 283.8 246.7 285.1Z",
    fill: "url(#paint34_linear_6686_51309)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M245.301 285.1C245.301 285.6 244.901 286.1 244.301 286.1C243.701 286.1 243.301 285.7 243.301 285.1C243.301 284.6 243.701 284.1 244.301 284.1C244.901 284.1 245.301 284.5 245.301 285.1Z",
    fill: "#121B2E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M476.301 306H390.601C387.701 306 385.301 303.6 385.301 300.7V255.1C385.301 252.2 387.701 249.8 390.601 249.8H476.301C479.201 249.8 481.601 252.2 481.601 255.1V300.7C481.501 303.7 479.201 306 476.301 306Z",
    fill: "#283D7E"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M390.601 304.5C388.501 304.5 386.801 302.8 386.801 300.7V255.1C386.801 253 388.501 251.3 390.601 251.3H476.301C478.401 251.3 480.101 253 480.101 255.1V300.7C480.101 302.8 478.401 304.5 476.301 304.5H390.601Z",
    fill: "#0B0F3C"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M390.601 303.5C389.101 303.5 387.801 302.3 387.801 300.7V255.1C387.801 253.6 389.001 252.3 390.601 252.3H476.301C477.801 252.3 479.101 253.5 479.101 255.1V300.7C479.101 302.2 477.901 303.5 476.301 303.5H390.601Z",
    fill: "#262757"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M401.7 273.5C405.3 273.5 408.3 270.5 408.3 266.9C408.3 263.3 405.3 260.3 401.7 260.3C398.1 260.3 395.1 263.3 395.1 266.9C395.1 270.5 398.1 273.5 401.7 273.5ZM401.7 274.8C406 274.8 409.5 271.3 409.5 267C409.5 262.7 406 259.2 401.7 259.2C397.4 259.2 393.9 262.7 393.9 267C393.9 271.3 397.4 274.8 401.7 274.8Z",
    fill: "#262757"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M402.5 259.1C402.2 259.1 402 259.1 401.7 259.1C397.4 259.1 393.9 262.6 393.9 266.9C393.9 271.2 397.4 274.7 401.7 274.7C406 274.7 409.5 271.2 409.5 266.9C409.5 266.6 409.5 266.2 409.4 265.9H408.1C408.2 266.2 408.2 266.6 408.2 266.9C408.2 270.5 405.2 273.5 401.6 273.5C398 273.5 395 270.5 395 266.9C395 263.3 398 260.3 401.6 260.3C401.9 260.3 402.1 260.3 402.4 260.3V259.1H402.5Z",
    fill: "#EA6B3D"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M401.7 296.4C405.3 296.4 408.3 293.4 408.3 289.8C408.3 286.2 405.3 283.2 401.7 283.2C398.1 283.2 395.1 286.2 395.1 289.8C395.1 293.4 398.1 296.4 401.7 296.4ZM401.7 297.6C406 297.6 409.5 294.1 409.5 289.8C409.5 285.5 406 282 401.7 282C397.4 282 393.9 285.5 393.9 289.8C393.9 294.1 397.4 297.6 401.7 297.6Z",
    fill: "#262757"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M402.5 282C402.2 282 402 282 401.7 282C397.4 282 393.9 285.5 393.9 289.8C393.9 294.1 397.4 297.6 401.7 297.6C406 297.6 409.5 294.1 409.5 289.8C409.5 289.5 409.5 289.1 409.4 288.8H408.1C408.2 289.1 408.2 289.5 408.2 289.8C408.2 293.4 405.2 296.4 401.6 296.4C398 296.4 395 293.4 395 289.8C395 286.2 398 283.2 401.6 283.2C401.9 283.2 402.1 283.2 402.4 283.2V282H402.5Z",
    fill: "#EA6B3D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.601 300.4H414.801V256.6H454.601V300.4ZM415.801 299.4H453.601V257.6H415.801V299.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.201 257.399H421.201V299.799H422.201V257.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.701 257.399H427.701V299.799H428.701V257.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.201 257.399H434.201V299.799H435.201V257.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.602 257.399H440.602V299.799H441.602V257.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.102 257.399H447.102V299.799H448.102V257.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.2 264.8H415.5V265.8H454.2V264.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.2 273.7H415.5V274.7H454.2V273.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.2 282.6H415.5V283.6H454.2V282.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.2 291.399H415.5V292.399H454.2V291.399Z",
    fill: "white"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 258.4H460.601C460.201 258.4 459.801 258.1 459.801 257.6C459.801 257.2 460.101 256.8 460.601 256.8H476.401C476.801 256.8 477.201 257.1 477.201 257.6C477.201 258.1 476.801 258.4 476.401 258.4Z",
    fill: "#0B0F3C"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 261.3H460.601C460.201 261.3 459.801 261 459.801 260.5C459.801 260.1 460.101 259.7 460.601 259.7H476.401C476.801 259.7 477.201 260 477.201 260.5C477.201 261 476.801 261.3 476.401 261.3Z",
    fill: "#0B0F3C"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M470.901 264.3H460.601C460.201 264.3 459.801 264 459.801 263.5C459.801 263.1 460.101 262.7 460.601 262.7H470.901C471.301 262.7 471.701 263 471.701 263.5C471.601 263.9 471.301 264.3 470.901 264.3Z",
    fill: "#0B0F3C"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 267.2H460.601C460.201 267.2 459.801 266.9 459.801 266.4C459.801 266 460.101 265.6 460.601 265.6H476.401C476.801 265.6 477.201 265.9 477.201 266.4C477.201 266.8 476.801 267.2 476.401 267.2Z",
    fill: "#0B0F3C"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M462.801 270.1H460.501C460.101 270.1 459.701 269.8 459.701 269.3C459.701 268.9 460.001 268.5 460.501 268.5H462.801C463.201 268.5 463.601 268.8 463.601 269.3C463.601 269.7 463.301 270.1 462.801 270.1Z",
    fill: "#0B0F3C"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 273H460.601C460.201 273 459.801 272.7 459.801 272.2C459.801 271.8 460.101 271.4 460.601 271.4H476.401C476.801 271.4 477.201 271.7 477.201 272.2C477.201 272.6 476.801 273 476.401 273Z",
    fill: "#0B0F3C"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 275.9H460.601C460.201 275.9 459.801 275.6 459.801 275.1C459.801 274.7 460.101 274.3 460.601 274.3H476.401C476.801 274.3 477.201 274.6 477.201 275.1C477.201 275.5 476.801 275.9 476.401 275.9Z",
    fill: "#0B0F3C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M471.801 278.8H460.601C460.201 278.8 459.801 278.5 459.801 278C459.801 277.6 460.101 277.2 460.601 277.2H471.801C472.201 277.2 472.601 277.5 472.601 278C472.601 278.4 472.201 278.8 471.801 278.8Z",
    fill: "#0B0F3C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 281.7H460.601C460.201 281.7 459.801 281.4 459.801 280.9C459.801 280.5 460.101 280.1 460.601 280.1H476.401C476.801 280.1 477.201 280.4 477.201 280.9C477.201 281.3 476.801 281.7 476.401 281.7Z",
    fill: "#0B0F3C"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M475.601 284.6H460.601C460.201 284.6 459.801 284.3 459.801 283.8C459.801 283.4 460.101 283 460.601 283H475.601C476.001 283 476.401 283.3 476.401 283.8C476.401 284.2 476.001 284.6 475.601 284.6Z",
    fill: "#0B0F3C"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 287.5H460.601C460.201 287.5 459.801 287.2 459.801 286.7C459.801 286.3 460.101 285.9 460.601 285.9H476.401C476.801 285.9 477.201 286.2 477.201 286.7C477.201 287.1 476.801 287.5 476.401 287.5Z",
    fill: "#0B0F3C"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M466.801 290.4H460.601C460.201 290.4 459.801 290.1 459.801 289.6C459.801 289.2 460.101 288.8 460.601 288.8H466.801C467.201 288.8 467.601 289.1 467.601 289.6C467.601 290.1 467.201 290.4 466.801 290.4Z",
    fill: "#0B0F3C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 293.3H460.601C460.201 293.3 459.801 293 459.801 292.5C459.801 292.1 460.101 291.7 460.601 291.7H476.401C476.801 291.7 477.201 292 477.201 292.5C477.201 293 476.801 293.3 476.401 293.3Z",
    fill: "#0B0F3C"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M476.401 296.2H460.601C460.201 296.2 459.801 295.9 459.801 295.4C459.801 295 460.101 294.6 460.601 294.6H476.401C476.801 294.6 477.201 294.9 477.201 295.4C477.201 295.9 476.801 296.2 476.401 296.2Z",
    fill: "#0B0F3C"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M146.3 305.7H83.0004C79.9004 305.7 77.4004 303.2 77.4004 300.1V255.5C77.4004 252.4 79.9004 249.9 83.0004 249.9H146.2C149.3 249.9 151.8 252.4 151.8 255.5V300.1C151.8 303.2 149.3 305.7 146.3 305.7Z",
    fill: "#283D7E"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0004 304.2C80.8004 304.2 78.9004 302.4 78.9004 300.1V255.5C78.9004 253.3 80.7004 251.4 83.0004 251.4H146.2C148.4 251.4 150.3 253.2 150.3 255.5V300.1C150.3 302.3 148.5 304.2 146.2 304.2H83.0004Z",
    fill: "#0B0F3C"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0004 303.2C81.3004 303.2 79.9004 301.8 79.9004 300.1V255.5C79.9004 253.8 81.3004 252.4 83.0004 252.4H146.2C147.9 252.4 149.3 253.8 149.3 255.5V300.1C149.3 301.8 147.9 303.2 146.2 303.2H83.0004Z",
    fill: "#262757"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 258.4H126.7C126.3 258.4 125.9 258.1 125.9 257.6C125.9 257.2 126.2 256.8 126.7 256.8H142.5C142.9 256.8 143.3 257.1 143.3 257.6C143.3 258.1 143 258.4 142.5 258.4Z",
    fill: "#0B0F3C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 261.3H126.7C126.3 261.3 125.9 261 125.9 260.5C125.9 260.1 126.2 259.7 126.7 259.7H142.5C142.9 259.7 143.3 260 143.3 260.5C143.3 261 143 261.3 142.5 261.3Z",
    fill: "#0B0F3C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M137 264.3H126.7C126.3 264.3 125.9 264 125.9 263.5C125.9 263.1 126.2 262.7 126.7 262.7H137C137.4 262.7 137.8 263 137.8 263.5C137.8 263.9 137.4 264.3 137 264.3Z",
    fill: "#0B0F3C"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 267.2H126.7C126.3 267.2 125.9 266.9 125.9 266.4C125.9 266 126.2 265.6 126.7 265.6H142.5C142.9 265.6 143.3 265.9 143.3 266.4C143.3 266.8 143 267.2 142.5 267.2Z",
    fill: "#0B0F3C"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M129 270.1H126.7C126.3 270.1 125.9 269.8 125.9 269.3C125.9 268.9 126.2 268.5 126.7 268.5H129C129.4 268.5 129.8 268.8 129.8 269.3C129.7 269.7 129.4 270.1 129 270.1Z",
    fill: "#0B0F3C"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 273H126.7C126.3 273 125.9 272.7 125.9 272.2C125.9 271.8 126.2 271.4 126.7 271.4H142.5C142.9 271.4 143.3 271.7 143.3 272.2C143.3 272.6 143 273 142.5 273Z",
    fill: "#0B0F3C"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 275.9H126.7C126.3 275.9 125.9 275.6 125.9 275.1C125.9 274.7 126.2 274.3 126.7 274.3H142.5C142.9 274.3 143.3 274.6 143.3 275.1C143.3 275.5 143 275.9 142.5 275.9Z",
    fill: "#0B0F3C"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M138 278.8H126.8C126.4 278.8 126 278.5 126 278C126 277.6 126.3 277.2 126.8 277.2H138C138.4 277.2 138.8 277.5 138.8 278C138.7 278.4 138.4 278.8 138 278.8Z",
    fill: "#0B0F3C"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 281.7H126.7C126.3 281.7 125.9 281.4 125.9 280.9C125.9 280.5 126.2 280.1 126.7 280.1H142.5C142.9 280.1 143.3 280.4 143.3 280.9C143.3 281.3 143 281.7 142.5 281.7Z",
    fill: "#0B0F3C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M141.8 284.6H126.8C126.4 284.6 126 284.3 126 283.8C126 283.4 126.3 283 126.8 283H141.8C142.2 283 142.6 283.3 142.6 283.8C142.5 284.2 142.2 284.6 141.8 284.6Z",
    fill: "#0B0F3C"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 287.5H126.7C126.3 287.5 125.9 287.2 125.9 286.7C125.9 286.3 126.2 285.9 126.7 285.9H142.5C142.9 285.9 143.3 286.2 143.3 286.7C143.3 287.1 143 287.5 142.5 287.5Z",
    fill: "#0B0F3C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M133 290.4H126.8C126.4 290.4 126 290.1 126 289.6C126 289.2 126.3 288.8 126.8 288.8H133C133.4 288.8 133.8 289.1 133.8 289.6C133.7 290.1 133.4 290.4 133 290.4Z",
    fill: "#0B0F3C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 293.3H126.7C126.3 293.3 125.9 293 125.9 292.5C125.9 292.1 126.2 291.7 126.7 291.7H142.5C142.9 291.7 143.3 292 143.3 292.5C143.3 293 143 293.3 142.5 293.3Z",
    fill: "#0B0F3C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 296.2H126.7C126.3 296.2 125.9 295.9 125.9 295.4C125.9 295 126.2 294.6 126.7 294.6H142.5C142.9 294.6 143.3 294.9 143.3 295.4C143.3 295.9 143 296.2 142.5 296.2Z",
    fill: "#0B0F3C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 258.4H106.8C106.4 258.4 106 258.1 106 257.6C106 257.2 106.3 256.8 106.8 256.8H122.6C123 256.8 123.4 257.1 123.4 257.6C123.3 258.1 123 258.4 122.6 258.4Z",
    fill: "#0B0F3C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 261.3H106.8C106.4 261.3 106 261 106 260.5C106 260.1 106.3 259.7 106.8 259.7H122.6C123 259.7 123.4 260 123.4 260.5C123.3 261 123 261.3 122.6 261.3Z",
    fill: "#0B0F3C"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M117 264.3H106.7C106.3 264.3 105.9 264 105.9 263.5C105.9 263.1 106.2 262.7 106.7 262.7H117C117.4 262.7 117.8 263 117.8 263.5C117.8 263.9 117.4 264.3 117 264.3Z",
    fill: "#0B0F3C"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 267.2H106.8C106.4 267.2 106 266.9 106 266.4C106 266 106.3 265.6 106.8 265.6H122.6C123 265.6 123.4 265.9 123.4 266.4C123.3 266.8 123 267.2 122.6 267.2Z",
    fill: "#0B0F3C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M109 270.1H106.7C106.3 270.1 105.9 269.8 105.9 269.3C105.9 268.9 106.2 268.5 106.7 268.5H109C109.4 268.5 109.8 268.8 109.8 269.3C109.7 269.7 109.4 270.1 109 270.1Z",
    fill: "#0B0F3C"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 273H106.8C106.4 273 106 272.7 106 272.2C106 271.8 106.3 271.4 106.8 271.4H122.6C123 271.4 123.4 271.7 123.4 272.2C123.3 272.6 123 273 122.6 273Z",
    fill: "#0B0F3C"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 275.9H106.8C106.4 275.9 106 275.6 106 275.1C106 274.7 106.3 274.3 106.8 274.3H122.6C123 274.3 123.4 274.6 123.4 275.1C123.3 275.5 123 275.9 122.6 275.9Z",
    fill: "#0B0F3C"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M118 278.8H106.8C106.4 278.8 106 278.5 106 278C106 277.6 106.3 277.2 106.8 277.2H118C118.4 277.2 118.8 277.5 118.8 278C118.7 278.4 118.4 278.8 118 278.8Z",
    fill: "#0B0F3C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 281.7H106.8C106.4 281.7 106 281.4 106 280.9C106 280.5 106.3 280.1 106.8 280.1H122.6C123 280.1 123.4 280.4 123.4 280.9C123.3 281.3 123 281.7 122.6 281.7Z",
    fill: "#0B0F3C"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M121.8 284.6H106.8C106.4 284.6 106 284.3 106 283.8C106 283.4 106.3 283 106.8 283H121.8C122.2 283 122.6 283.3 122.6 283.8C122.5 284.2 122.2 284.6 121.8 284.6Z",
    fill: "#0B0F3C"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 287.5H106.8C106.4 287.5 106 287.2 106 286.7C106 286.3 106.3 285.9 106.8 285.9H122.6C123 285.9 123.4 286.2 123.4 286.7C123.3 287.1 123 287.5 122.6 287.5Z",
    fill: "#0B0F3C"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M113 290.4H106.8C106.4 290.4 106 290.1 106 289.6C106 289.2 106.3 288.8 106.8 288.8H113C113.4 288.8 113.8 289.1 113.8 289.6C113.7 290.1 113.4 290.4 113 290.4Z",
    fill: "#0B0F3C"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 293.3H106.8C106.4 293.3 106 293 106 292.5C106 292.1 106.3 291.7 106.8 291.7H122.6C123 291.7 123.4 292 123.4 292.5C123.3 293 123 293.3 122.6 293.3Z",
    fill: "#0B0F3C"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M122.6 296.2H106.8C106.4 296.2 106 295.9 106 295.4C106 295 106.3 294.6 106.8 294.6H122.6C123 294.6 123.4 294.9 123.4 295.4C123.3 295.9 123 296.2 122.6 296.2Z",
    fill: "#0B0F3C"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M281.6 243.6H242.1V248.8H281.6V243.6Z",
    fill: "#0B0F3C"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M248.799 248.8H244.199L249.099 243.6H253.699L248.799 248.8Z",
    fill: "#262757"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M257.799 248.8H253.199L257.999 243.6H262.599L257.799 248.8Z",
    fill: "#262757"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M266.8 248.8H262.1L267 243.6H271.6L266.8 248.8Z",
    fill: "#262757"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M275.7 248.8H271.1L276 243.6H280.6L275.7 248.8Z",
    fill: "#262757"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M212.399 339.3H49.1992V345.6H212.399V339.3Z",
    fill: "#0B0F3C"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M110.8 339.4H211.7C212 339.4 212.3 339.3 212.5 339.1L236 318.8C236.9 318 236.3 316.6 235.2 316.6H134.3C134 316.6 133.7 316.7 133.5 316.9L110 337.2C109.1 337.9 109.7 339.4 110.8 339.4Z",
    fill: "url(#paint35_linear_6686_51309)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M211.699 339.4L221.799 371.1L208.199 342.4L211.699 339.4Z",
    fill: "#0B0F3C"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M235.999 318.8L211.699 339.4L221.299 369.6L235.999 318.8Z",
    fill: "url(#paint36_linear_6686_51309)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M187.399 320.8C189.111 320.8 190.499 320.397 190.499 319.9C190.499 319.403 189.111 319 187.399 319C185.687 319 184.299 319.403 184.299 319.9C184.299 320.397 185.687 320.8 187.399 320.8Z",
    fill: "url(#paint37_linear_6686_51309)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M196.299 320.8C198.011 320.8 199.399 320.397 199.399 319.9C199.399 319.403 198.011 319 196.299 319C194.587 319 193.199 319.403 193.199 319.9C193.199 320.397 194.587 320.8 196.299 320.8Z",
    fill: "url(#paint38_linear_6686_51309)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M205.1 320.8C206.812 320.8 208.2 320.397 208.2 319.9C208.2 319.403 206.812 319 205.1 319C203.388 319 202 319.403 202 319.9C202 320.397 203.388 320.8 205.1 320.8Z",
    fill: "url(#paint39_linear_6686_51309)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M199.899 324.2C201.611 324.2 202.999 323.797 202.999 323.3C202.999 322.803 201.611 322.4 199.899 322.4C198.187 322.4 196.799 322.803 196.799 323.3C196.799 323.797 198.187 324.2 199.899 324.2Z",
    fill: "url(#paint40_linear_6686_51309)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M190.5 324.2C192.212 324.2 193.6 323.797 193.6 323.3C193.6 322.803 192.212 322.4 190.5 322.4C188.788 322.4 187.4 322.803 187.4 323.3C187.4 323.797 188.788 324.2 190.5 324.2Z",
    fill: "#262757"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M181.2 324.2C182.912 324.2 184.3 323.797 184.3 323.3C184.3 322.803 182.912 322.4 181.2 322.4C179.488 322.4 178.1 322.803 178.1 323.3C178.1 323.797 179.488 324.2 181.2 324.2Z",
    fill: "url(#paint41_linear_6686_51309)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M195.899 327.6C197.611 327.6 198.999 327.197 198.999 326.7C198.999 326.203 197.611 325.8 195.899 325.8C194.187 325.8 192.799 326.203 192.799 326.7C192.799 327.197 194.187 327.6 195.899 327.6Z",
    fill: "url(#paint42_linear_6686_51309)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M215.299 320.8C217.011 320.8 218.399 320.397 218.399 319.9C218.399 319.403 217.011 319 215.299 319C213.587 319 212.199 319.403 212.199 319.9C212.199 320.397 213.587 320.8 215.299 320.8Z",
    fill: "url(#paint43_linear_6686_51309)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M210 324.2C211.712 324.2 213.1 323.797 213.1 323.3C213.1 322.803 211.712 322.4 210 322.4C208.288 322.4 206.9 322.803 206.9 323.3C206.9 323.797 208.288 324.2 210 324.2Z",
    fill: "url(#paint44_linear_6686_51309)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M206.1 327.6C207.812 327.6 209.2 327.197 209.2 326.7C209.2 326.203 207.812 325.8 206.1 325.8C204.388 325.8 203 326.203 203 326.7C203 327.197 204.388 327.6 206.1 327.6Z",
    fill: "url(#paint45_linear_6686_51309)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M225.2 320.8C226.912 320.8 228.3 320.397 228.3 319.9C228.3 319.403 226.912 319 225.2 319C223.488 319 222.1 319.403 222.1 319.9C222.1 320.397 223.488 320.8 225.2 320.8Z",
    fill: "url(#paint46_linear_6686_51309)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M220 324.2C221.712 324.2 223.1 323.797 223.1 323.3C223.1 322.803 221.712 322.4 220 322.4C218.288 322.4 216.9 322.803 216.9 323.3C216.9 323.797 218.288 324.2 220 324.2Z",
    fill: "url(#paint47_linear_6686_51309)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M216.1 327.6C217.812 327.6 219.2 327.197 219.2 326.7C219.2 326.203 217.812 325.8 216.1 325.8C214.388 325.8 213 326.203 213 326.7C213 327.197 214.388 327.6 216.1 327.6Z",
    fill: "url(#paint48_linear_6686_51309)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M185.399 327.6C187.111 327.6 188.499 327.197 188.499 326.7C188.499 326.203 187.111 325.8 185.399 325.8C183.687 325.8 182.299 326.203 182.299 326.7C182.299 327.197 183.687 327.6 185.399 327.6Z",
    fill: "#262757"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M175.299 327.6C177.011 327.6 178.399 327.197 178.399 326.7C178.399 326.203 177.011 325.8 175.299 325.8C173.587 325.8 172.199 326.203 172.199 326.7C172.199 327.197 173.587 327.6 175.299 327.6Z",
    fill: "#262757"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M191.1 331.2C192.812 331.2 194.2 330.797 194.2 330.3C194.2 329.803 192.812 329.4 191.1 329.4C189.388 329.4 188 329.803 188 330.3C188 330.797 189.388 331.2 191.1 331.2Z",
    fill: "url(#paint49_linear_6686_51309)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M201.299 331.2C203.011 331.2 204.399 330.797 204.399 330.3C204.399 329.803 203.011 329.4 201.299 329.4C199.587 329.4 198.199 329.803 198.199 330.3C198.199 330.797 199.587 331.2 201.299 331.2Z",
    fill: "url(#paint50_linear_6686_51309)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M211.299 331.2C213.011 331.2 214.399 330.797 214.399 330.3C214.399 329.803 213.011 329.4 211.299 329.4C209.587 329.4 208.199 329.803 208.199 330.3C208.199 330.797 209.587 331.2 211.299 331.2Z",
    fill: "#FF6F37"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M180.299 331.2C182.011 331.2 183.399 330.797 183.399 330.3C183.399 329.803 182.011 329.4 180.299 329.4C178.587 329.4 177.199 329.803 177.199 330.3C177.199 330.797 178.587 331.2 180.299 331.2Z",
    fill: "#262757"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M170 331.2C171.712 331.2 173.1 330.797 173.1 330.3C173.1 329.803 171.712 329.4 170 329.4C168.288 329.4 166.9 329.803 166.9 330.3C166.9 330.797 168.288 331.2 170 331.2Z",
    fill: "#262757"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M186.2 334.8C187.912 334.8 189.3 334.397 189.3 333.9C189.3 333.403 187.912 333 186.2 333C184.488 333 183.1 333.403 183.1 333.9C183.1 334.397 184.488 334.8 186.2 334.8Z",
    fill: "url(#paint51_linear_6686_51309)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M175.2 334.8C176.912 334.8 178.3 334.397 178.3 333.9C178.3 333.403 176.912 333 175.2 333C173.488 333 172.1 333.403 172.1 333.9C172.1 334.397 173.488 334.8 175.2 334.8Z",
    fill: "#262757"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M164.2 334.8C165.912 334.8 167.3 334.397 167.3 333.9C167.3 333.403 165.912 333 164.2 333C162.488 333 161.1 333.403 161.1 333.9C161.1 334.397 162.488 334.8 164.2 334.8Z",
    fill: "#262757"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M207 335.6H193.2C192.5 335.6 192.2 334.8 192.8 334.3L193.6 333.6C194.1 333.2 194.7 332.9 195.3 332.9H208.8C209.5 332.9 209.9 333.7 209.4 334.2L208.7 334.9C208.2 335.4 207.6 335.6 207 335.6Z",
    fill: "url(#paint52_linear_6686_51309)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M139.299 334.8L155.599 334.3L172.899 321.7L139.299 334.8Z",
    fill: "#0B0F3C"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M475.9 339.3H313.5V345.6H476V339.3H475.9Z",
    fill: "#0B0F3C"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M441.9 339.6H314.2C313.9 339.6 313.6 339.5 313.4 339.3L289.9 319C289 318.2 289.6 316.8 290.7 316.8H418.3C418.6 316.8 418.9 316.9 419.1 317.1L442.6 337.4C443.6 338.2 443.1 339.6 441.9 339.6Z",
    fill: "url(#paint53_linear_6686_51309)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M313.801 339.4L303.801 371.1L317.401 342.4L313.801 339.4Z",
    fill: "#0B0F3C"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M289.5 318.8L313.8 339.4L304.1 369.6L289.5 318.8Z",
    fill: "url(#paint54_linear_6686_51309)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.101 318.8H308.401C309.401 318.8 310.401 319.1 311.201 319.7L331.601 335C332.001 335.3 331.801 336.1 331.201 336.1H318.401C317.301 336.1 316.301 335.7 315.501 335.1L296.701 319.9C296.301 319.5 296.601 318.8 297.101 318.8Z",
    fill: "#1A1E51"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M313.702 321.7L311.502 320C311.302 320 311.202 320 311.002 320.1C310.702 320.2 310.502 320.5 310.502 320.8C310.402 321.5 311.302 322.8 313.302 325.7C314.002 326.8 315.002 328.1 315.402 328.9C314.702 328.6 313.502 327.6 312.602 327C310.402 325.3 309.102 324.4 308.302 324.7L308.002 325C307.902 325.2 307.802 325.7 312.502 332.6L315.102 334.7L315.202 334.6C313.102 331.7 310.402 327.6 309.402 325.8C310.202 326.2 311.302 327.1 312.002 327.7C314.302 329.5 315.602 330.4 316.302 329.8C317.002 329.3 316.402 328.3 314.102 325.1C313.102 323.6 311.502 321.3 311.502 320.9C311.802 320.8 312.802 321.2 313.702 321.7Z",
    fill: "url(#paint55_linear_6686_51309)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M326.502 332.3H322.602L323.802 333H327.702L326.502 332.3Z",
    fill: "#EA6B3D"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M328.4 333.6H324.4L325.6 334.4H329.5L328.4 333.6Z",
    fill: "#EA6B3D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.502 132.1C481.502 135.2 481.002 138.2 479.902 141C479.402 142.2 478.902 143.5 478.202 144.6C477.202 146.4 476.002 148 474.602 149.4C474.102 149.9 473.602 150.4 473.102 150.9C468.602 154.9 462.702 157.3 456.302 157.3C442.902 157.3 431.902 146.8 431.102 133.6C431.102 133.2 431.102 132.7 431.102 132.3C431.102 132.2 431.102 132.2 431.102 132.1C431.102 129.5 431.502 127 432.202 124.7C432.602 123.5 433.002 122.3 433.602 121.1C437.702 112.7 446.302 106.9 456.302 106.9C470.202 106.9 481.502 118.2 481.502 132.1Z",
    fill: "url(#paint56_linear_6686_51309)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M479.901 141.5C473.801 138.4 466.601 134.9 458.701 131.5C449.901 127.7 441.301 124.3 433.601 121.7C417.901 116.2 406.001 113.5 403.601 115.1C400.601 117.2 412.401 125 431.101 134.1C431.101 133.7 431.101 133.2 431.101 132.8C428.701 131.6 426.401 130.3 424.301 129C420.701 126.8 417.301 124.2 416.401 121.6C416.401 121.5 416.501 121.4 416.601 121.4C417.001 121.4 417.301 121.4 417.701 121.4C419.601 121.5 421.501 121.9 423.401 122.4C425.701 123 428.001 123.8 430.201 124.5C430.901 124.8 431.601 125 432.401 125.3C436.101 126.7 439.701 128.1 443.301 129.5C445.501 130.4 447.701 131.2 450.001 132C453.101 133.2 456.301 134.4 459.301 135.7C462.401 137 465.401 138.3 468.301 139.8C469.701 140.5 471.001 141.3 472.401 142C473.501 142.6 474.501 143.1 475.501 143.6C476.501 144.1 477.401 144.6 478.301 145.1C479.701 145.9 481.001 146.6 482.201 147.5C484.101 148.8 485.901 150.2 486.701 151.7C486.801 151.8 486.701 152 486.401 152C486.101 152 485.801 152 485.401 151.9C482.501 151.6 479.501 151.1 476.601 150.5C475.901 150.4 475.201 150.2 474.601 150.1C474.101 150.6 473.601 151.1 473.101 151.6C487.501 156.5 498.301 158.9 500.601 157.3C503.201 155.3 494.601 149.1 479.901 141.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M471.102 111.7C471.402 112 471.602 112.4 471.902 112.7C472.502 113.5 473.102 114.4 473.502 115.3C473.802 116.1 474.002 117 473.802 117.9C473.502 118.7 473.102 119.5 472.402 120C471.802 120.3 471.102 120.3 470.402 120.1C469.002 119.7 467.802 118.7 466.402 118.4C465.802 118.3 465.302 118.4 464.902 118.9C464.502 119.4 464.502 119.9 464.802 120.5C465.202 121.1 465.902 121.6 466.402 122C467.202 122.5 468.002 123 468.802 123.4C469.502 123.8 470.202 124.1 470.802 124.6C471.002 124.7 471.202 124.9 471.402 125.1C471.702 125.2 471.902 125.4 472.202 125.5C472.802 125.9 473.402 126.5 473.502 127.1C473.602 127.9 473.202 128.8 472.502 129.2C471.602 129.7 470.502 129.3 469.602 129.5C469.402 129.6 469.202 129.8 469.102 130C468.802 130.4 468.502 130.9 468.302 131.5C467.702 133.5 469.302 135.3 470.102 136.9C470.502 137.7 470.802 138.7 470.802 139.6C470.902 140.1 470.902 140.7 470.802 141.3C470.702 142.2 470.202 142.9 469.402 143.4C469.202 143.6 468.902 143.7 468.602 143.7C468.502 143.7 468.402 143.7 468.302 143.8C467.602 143.9 466.902 143.7 466.102 143.6C465.802 143.6 465.402 143.6 465.102 143.6C464.102 143.9 463.102 144.1 462.102 144.6C461.402 145 460.902 145.5 460.302 146.1C459.802 146.9 459.302 147.6 458.802 148.4C458.302 149.1 457.702 149.9 457.002 150.5C455.302 151.9 453.002 152.1 450.902 151.9C445.702 151.3 441.202 148.3 437.402 144.8C435.502 143 433.702 141.1 431.902 139.2C435.002 149.6 444.602 157.3 456.102 157.3C462.502 157.3 468.402 154.9 472.902 150.9C473.402 150.4 473.902 149.9 474.402 149.4C475.802 147.9 477.002 146.3 478.002 144.6C478.702 143.5 479.202 142.3 479.702 141C480.702 138.3 481.302 135.3 481.302 132.1C481.502 123.7 477.402 116.3 471.102 111.7Z",
    fill: "#FEFBFD"
  }))), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M206.1 52.2C213.887 52.2 220.2 45.8872 220.2 38.1C220.2 30.3128 213.887 24 206.1 24C198.313 24 192 30.3128 192 38.1C192 45.8872 198.313 52.2 206.1 52.2Z",
    fill: "url(#paint57_radial_6686_51309)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.9 130.6C136.815 130.6 140.8 126.615 140.8 121.7C140.8 116.784 136.815 112.8 131.9 112.8C126.985 112.8 123 116.784 123 121.7C123 126.615 126.985 130.6 131.9 130.6Z",
    fill: "url(#paint58_linear_6686_51309)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M483.9 38.1001C484.729 38.1001 485.4 37.4285 485.4 36.6001C485.4 35.7717 484.729 35.1001 483.9 35.1001C483.072 35.1001 482.4 35.7717 482.4 36.6001C482.4 37.4285 483.072 38.1001 483.9 38.1001Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M206.4 78.7998C207.229 78.7998 207.9 78.1282 207.9 77.2998C207.9 76.4714 207.229 75.7998 206.4 75.7998C205.572 75.7998 204.9 76.4714 204.9 77.2998C204.9 78.1282 205.572 78.7998 206.4 78.7998Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M334.701 105.5C335.53 105.5 336.201 104.828 336.201 104C336.201 103.172 335.53 102.5 334.701 102.5C333.873 102.5 333.201 103.172 333.201 104C333.201 104.828 333.873 105.5 334.701 105.5Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2008 99.4001C78.8024 99.4001 80.1008 98.1017 80.1008 96.5001C80.1008 94.8985 78.8024 93.6001 77.2008 93.6001C75.5991 93.6001 74.3008 94.8985 74.3008 96.5001C74.3008 98.1017 75.5991 99.4001 77.2008 99.4001Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M155.701 75.8C157.302 75.8 158.601 74.5016 158.601 72.9C158.601 71.2984 157.302 70 155.701 70C154.099 70 152.801 71.2984 152.801 72.9C152.801 74.5016 154.099 75.8 155.701 75.8Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M426.201 182.4C427.802 182.4 429.101 181.102 429.101 179.5C429.101 177.898 427.802 176.6 426.201 176.6C424.599 176.6 423.301 177.898 423.301 179.5C423.301 181.102 424.599 182.4 426.201 182.4Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M336.101 57.2001C336.543 57.2001 336.901 56.8419 336.901 56.4001C336.901 55.9583 336.543 55.6001 336.101 55.6001C335.659 55.6001 335.301 55.9583 335.301 56.4001C335.301 56.8419 335.659 57.2001 336.101 57.2001Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7012 14.5C99.5296 14.5 100.201 13.8284 100.201 13C100.201 12.1716 99.5296 11.5 98.7012 11.5C97.8727 11.5 97.2012 12.1716 97.2012 13C97.2012 13.8284 97.8727 14.5 98.7012 14.5Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M299.6 337.5C301.1 337.4 302.4 339.4 302.6 341.8C302.7 344.3 301.6 346.4 300.1 346.5L293.1 346.9L292.6 337.9L299.6 337.5Z",
    fill: "#0B0F3C"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M295.6 342.2C295.7 344.7 294.6 346.8 293.1 346.9C291.6 347 290.3 345 290.1 342.6C290 340.1 291.1 338 292.6 337.9C294.1 337.8 295.5 339.8 295.6 342.2Z",
    fill: "url(#paint59_linear_6686_51309)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M358.199 404.3C359.699 404.2 360.999 406.2 361.199 408.6C361.299 411.1 360.199 413.2 358.699 413.3L351.699 413.7L351.199 404.7L358.199 404.3Z",
    fill: "#0B0F3C"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M354.2 409C354.3 411.5 353.2 413.6 351.7 413.7C350.2 413.8 348.9 411.8 348.7 409.4C348.6 406.9 349.7 404.8 351.2 404.7C352.7 404.6 354.1 406.5 354.2 409Z",
    fill: "url(#paint60_linear_6686_51309)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M282.399 422.1C280.899 422.1 278.999 421.4 276.899 419.1C273.699 415.6 273.599 411.6 276.599 407.8C279.199 404.6 283.799 401.8 289.899 399.9C288.699 391.6 284.399 382.9 275.099 378C253.099 366.4 246.799 362.4 245.999 347.2C245.499 337 250.199 328.8 257.999 326.4C265.099 324.2 272.399 327.3 276.599 334.3C282.699 344.4 292.699 341.9 292.799 341.9L293.099 342.9C292.999 342.9 282.299 345.6 275.799 334.8C271.799 328.2 264.999 325.3 258.299 327.3C252.399 329.1 246.399 335.2 246.999 347.1C247.799 361.7 253.999 365.7 275.599 377.1C285.199 382.2 289.699 391.1 290.899 399.6C306.199 395.1 329.799 396.2 351.799 408.7L351.299 409.6C329.399 397.1 305.999 396.1 290.999 400.5C291.299 402.9 291.299 405.3 291.199 407.6C290.599 414.9 287.899 420.5 284.099 421.8C283.499 422 282.999 422.1 282.399 422.1ZM289.899 400.9C284.199 402.7 279.799 405.4 277.299 408.5C274.599 411.9 274.699 415.3 277.599 418.5C279.599 420.7 281.699 421.6 283.699 420.9C286.999 419.8 289.599 414.4 290.099 407.6C290.199 405.4 290.199 403.2 289.899 400.9Z",
    fill: "url(#paint61_linear_6686_51309)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M211.501 282C212.101 281 215.401 276.7 215.601 276.2C215.901 275.7 216.401 274.6 215.601 273.7C215.001 273 214.001 273.1 213.501 273.5C213.001 273.8 208.901 277.7 206.101 279.6C205.501 280 204.601 279.5 202.101 281.3C200.201 282.8 194.001 291.2 193.201 291.8C191.801 292.8 154.901 304.4 152.901 304.8C151.001 305.1 130.101 306.2 123.601 306.4C122.501 306.6 108.901 307.2 108.201 306.7C107.401 306.2 106.301 302.7 105.601 302C104.901 301.3 74.8008 300.2 73.0008 301.2C72.1008 301.7 74.4008 304.2 71.1008 307.8C70.0008 309.4 65.5008 311 63.9008 311.8C52.1008 315.9 50.1008 344.8 49.3008 345.8C49.8008 346.1 50.3008 346.5 50.7008 346.9C57.5008 352.3 64.7008 357.4 72.0008 362.2C75.6008 364.5 79.1008 366.8 82.8008 369C86.3008 371.2 89.9008 373.4 93.4008 375.4C97.0008 377.5 100.601 379.5 104.401 381.3C108.201 383.1 112.101 384.7 116.201 385.7C124.001 387.6 132.101 387.7 140.101 387.7C139.801 386.3 139.401 385 139.001 383.6C136.401 374 128.701 339.5 129.001 339.4C131.901 339.7 161.901 330.1 167.601 327.4C170.301 326.1 198.601 302 200.401 300.9C201.901 300 211.301 295.8 213.101 293.1C214.101 291.9 214.301 290.4 214.101 289.4C214.001 289.1 214.301 288.5 214.201 287.9C214.001 287.1 213.701 287 213.601 286.8C213.501 286.7 213.601 285.7 213.401 285.1C213.201 284.5 212.701 284.5 212.701 284.4C212.701 284.4 212.701 283.5 212.601 283C212.201 282.1 211.601 282.2 211.501 282Z",
    fill: "url(#paint62_linear_6686_51309)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3008 306.4C106.301 306.4 119.201 293.8 119.201 278.2C119.201 262.6 106.301 250 90.3008 250C74.3008 250 59.4008 264.9 61.2008 281C63.4008 299.9 74.4008 306.4 90.3008 306.4Z",
    fill: "url(#paint63_linear_6686_51309)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3009 285.6C88.9009 283.7 82.3009 267.2 97.7009 251.7C107.201 253.7 117.901 263.8 117.901 280.2C117.901 285.4 117.301 290.2 113.701 294.8C110.601 295.1 94.8009 295.3 90.3009 285.6Z",
    fill: "#0B0F3C"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M117 277.7C116.7 272.8 114.8 267.5 112.2 263.2C109.6 259 105.4 255.5 101 253.2C98.7004 252 96.2004 251.2 93.7004 250.3C93.4004 250.2 93.2004 250.1 92.9004 250C107.5 251 119.2 263.2 119.2 278.1C119.2 283.5 117.7 288.6 115 292.9C115.3 292.1 117.9 286.3 117 277.7Z",
    fill: "url(#paint64_linear_6686_51309)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.399 285.6L108.099 283.2C108.099 283.2 107.299 280.8 107.299 280.4C107.299 280 109.599 278 109.199 277.1C108.799 276.2 102.599 270.3 102.599 270.3C102.599 270.3 101.699 265.9 99.7992 263.5C97.8992 261.1 94.2992 256.9 94.2992 256.9C94.2992 256.9 90.7992 266.1 87.6992 274.5C87.7992 280.4 89.5992 284.7 90.2992 285.6C92.7992 290.9 98.4992 293.2 103.799 294.2C108.399 292.5 109.899 291.4 109.799 290.4C109.699 288.6 108.399 285.6 108.399 285.6Z",
    fill: "url(#paint65_linear_6686_51309)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9009 282.6C85.9009 282.6 83.9009 274 87.4009 263C90.7009 252.6 94.8009 249.1 95.1009 249C96.6009 248.5 101.701 249.5 103.301 251.5C103.501 251.8 96.8009 254.4 91.3009 265.3C87.4009 273.1 87.0009 282.7 87.0009 282.7H85.9009V282.6Z",
    fill: "url(#paint66_linear_6686_51309)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M107.901 307.1L105.301 302.3C105.301 302.3 94.3008 302.6 84.0008 302.3C72.8008 302 67.7008 297.9 67.5008 298.5C67.1008 299.9 72.2008 302.9 70.7008 306.4C69.2008 309.8 66.3008 310.6 66.3008 310.6C66.3008 310.6 76.0008 313.8 87.6008 313.9C99.2008 314 107.901 307.1 107.901 307.1Z",
    fill: "#262757"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M213.5 273.5C213 273.8 208.9 277.7 206.1 279.6C205.5 280 204.6 279.5 202.1 281.3C200.2 282.8 194 291.2 193.2 291.8C191.8 292.8 154.9 304.4 152.9 304.8C151 305.1 130.1 306.2 123.6 306.4C122.5 306.6 108.9 307.2 108.2 306.7C108 306.6 107.9 306.4 107.7 306L103.4 309.6L110.2 314.4C114.4 309.9 124 308.4 125.1 309.3C127.2 310.9 128.7 315.2 128.9 315.1C129.1 315 126.8 308.8 127.1 308.7C127.4 308.6 154.1 310.3 155.4 310.8C156.7 311.3 155.8 305.5 157.6 304.7C159.4 303.9 161.3 314.5 162.2 313.4C165.2 309.5 160.3 305.4 161 304.2C161.7 303 166.1 308.3 166.8 307.7C167.5 307.1 188.1 295.4 189.6 295.2C191.1 295 190.7 293.6 191.2 293.8C191.7 294 192.4 294.7 193 294.9C193.6 295.1 195.6 293.9 195.8 293.3C196 292.7 201.8 283.1 202.7 282.2C203.6 281.3 205.7 280.1 205.7 280.1L205.3 281C205.3 281 213.2 274.3 214.3 274.3C215 274.3 215.7 274.7 216.1 275.1C216.1 274.7 216 274.3 215.7 273.9C215 273 214 273.1 213.5 273.5Z",
    fill: "url(#paint67_linear_6686_51309)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.8 293C208 296.3 199.3 298.9 197.5 300.2C195.7 301.5 172.2 314.2 167.5 317.7C162.8 321.3 139.4 318.7 126.9 318.5C114.4 318.3 105.9 324.3 110 314.4L103.2 309.6L100 303.9C100 303.9 104.2 302.7 105.4 301.9C111.2 298.1 113.4 294.8 113.4 294.8C113.4 294.8 100.1 295.4 93.7004 289.9C93.5004 289.7 85.0004 301.7 76.6004 287.2C69.0004 274.2 66.6004 263.4 67.4004 260.9C62.8004 266.4 60.1004 273.5 61.0004 280.8C61.9004 288.5 64.2004 294.2 67.8004 298.2C67.5004 298.2 67.4004 298.3 67.3004 298.4C66.9004 299.8 72.0004 302.8 70.5004 306.3C69.6004 308.3 68.3004 309.4 67.3004 309.9C66.9004 310.1 66.4004 310.3 66.0004 310.5C65.0004 311 64.0004 311.4 63.5004 311.7C56.3004 314.2 52.8004 325.8 50.9004 334.8L89.3004 378.1H129.9C129.9 378.1 115.2 359.8 109 341.4C110.8 344.2 113.3 346.9 116.8 348.4C126.9 352.9 131.2 351.8 131.2 351.8C131.2 351.8 123.5 350.8 119.5 346.9C117.2 344.7 116.4 342.8 116.2 341.7C122.8 344.3 129.5 343.6 129.5 343.6C128.9 340.9 128.6 339.3 128.7 339.3C131.6 339.6 161.6 330 167.3 327.3C170 326 198.3 301.9 200.1 300.8C201.6 299.9 211 295.7 212.8 293C213.5 292.2 213.9 291.2 213.9 290C213.6 291 212.9 292 211.8 293Z",
    fill: "#1A1E51"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.301 251.4C101.801 249.4 96.6008 248.4 95.1008 248.9C95.1008 248.9 94.9008 249 94.7008 249.2C96.0008 249.7 98.4008 250.6 99.1008 251.6C99.9008 252.8 95.3008 254.2 91.7008 261.9C88.2008 269.6 87.8008 274.6 87.8008 274.6H88.1008C88.7008 271.6 89.7008 268.3 91.3008 265.1C96.8008 254.3 103.501 251.7 103.301 251.4Z",
    fill: "url(#paint68_linear_6686_51309)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.9992 295.8C94.1992 293.6 96.2992 287 93.6992 280.9C90.9992 274.9 84.5992 271.7 79.3992 273.9C74.1992 276.1 72.0992 282.7 74.6992 288.8C77.3992 294.9 83.7992 298 88.9992 295.8Z",
    fill: "#1A1E51"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1006 294.9C92.4006 293.9 95.7006 288 94.6006 281.6C93.4006 275.2 88.2006 270.9 82.9006 271.9C77.6006 272.9 74.3006 278.8 75.4006 285.2C76.5006 291.6 81.8006 295.9 87.1006 294.9Z",
    fill: "url(#paint69_linear_6686_51309)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85.2007 289.7C88.1007 289.2 89.9007 285.9 89.3007 282.5C88.7007 279 85.8007 276.7 82.9007 277.2C80.0007 277.7 78.2007 281 78.8007 284.4C79.5007 287.9 82.4007 290.2 85.2007 289.7Z",
    fill: "#1A1E51"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9992 283C94.3992 284.9 94.3992 286.8 94.0992 288.5C94.7992 286.4 94.9992 284.1 94.5992 281.7C93.5992 276.1 89.2992 272 84.6992 271.9C89.0992 273 92.8992 277.3 93.9992 283Z",
    fill: "url(#paint70_linear_6686_51309)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.5 284.7C211.7 286.2 210.7 286.7 211 287.2C211.4 287.8 212.5 284.7 212.5 284.7Z",
    fill: "#1A1E51"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M211.301 282.1C210.501 283.6 209.501 284.1 209.801 284.6C210.201 285.2 211.301 282.1 211.301 282.1Z",
    fill: "#1A1E51"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M213.301 287.3C212.501 288.8 211.501 289.3 211.801 289.8C212.201 290.4 213.301 287.3 213.301 287.3Z",
    fill: "#1A1E51"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M191.3 432.4C191.3 432.4 95.2001 478.9 44.5001 421.7C37.0001 413.2 27.0001 352.4 22.2001 330.2C20.5001 322.6 26.3001 315.4 34.0001 315.3C55.0001 315.1 89.1001 316 97.1001 322.6C107.3 330.3 115.3 370.4 117.2 377.3L179 369C189.1 369 191.3 422.4 191.3 432.4Z",
    fill: "url(#paint71_linear_6686_51309)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.2 390.1L117.9 382.7C117.9 382.7 172.2 371.5 179.2 373.2C188.5 375.5 191.3 432.5 191.3 432.5C191.3 422.4 189.1 369.1 179 369.1L117.2 377.5C115.3 370.5 107.2 330.4 97.1004 322.8C86.5004 314.1 44.1004 315.2 32.9004 315.7C32.9004 315.7 45.7004 316.4 49.1004 316.6C59.6004 317.3 85.0004 321.5 92.1004 324.6C105.5 330.3 116.2 390.1 116.2 390.1Z",
    fill: "url(#paint72_linear_6686_51309)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.499 435C183.299 423.8 178.199 393.2 175.499 392.6C172.199 391.8 112.099 403.4 112.099 403.4C105.399 375.2 90.9992 339.6 85.6992 336.1C77.2992 330.4 32.4992 324 27.4992 326.7C25.2992 327.9 22.6992 329.4 22.6992 333C24.6992 342.6 27.3992 357.3 30.3992 372.1V372.2C30.4992 372.7 30.5992 373.3 30.6992 373.8C30.6992 373.9 30.6992 373.9 30.6992 374C30.7992 374.5 30.8992 375 30.9992 375.6C30.9992 375.7 30.9992 375.8 30.9992 375.8C31.0992 376.3 31.1992 376.8 31.2992 377.3C31.2992 377.4 31.2992 377.5 31.3992 377.6C31.4992 378.1 31.5992 378.6 31.6992 379.1C31.6992 379.2 31.6992 379.3 31.7992 379.4C31.8992 379.9 31.9992 380.4 32.0992 380.8C32.0992 380.9 32.0992 381 32.1992 381.1C32.2992 381.6 32.3992 382 32.4992 382.5C32.4992 382.6 32.5992 382.8 32.5992 382.9C32.6992 383.4 32.7992 383.8 32.8992 384.3C32.8992 384.4 32.9992 384.5 32.9992 384.7C33.0992 385.2 33.1992 385.7 33.2992 386.2C33.2992 386.3 33.2992 386.4 33.3992 386.5C33.4992 387 33.5992 387.5 33.6992 388C33.6992 388.1 33.6992 388.1 33.6992 388.2C33.7992 388.8 33.9992 389.3 34.0992 389.9C34.5992 392.2 35.0992 394.4 35.5992 396.5C35.5992 396.6 35.5992 396.6 35.5992 396.7C35.6992 397.2 35.7992 397.6 35.8992 398.1C35.8992 398.2 35.9992 398.3 35.9992 398.4C36.0992 398.8 36.1992 399.2 36.2992 399.6C36.2992 399.7 36.3992 399.9 36.3992 400C36.4992 400.4 36.5992 400.7 36.6992 401.1C36.6992 401.3 36.7992 401.4 36.7992 401.6C36.8992 401.9 36.9992 402.2 37.0992 402.6C37.0992 402.8 37.1992 403 37.1992 403.1C37.2992 403.4 37.3992 403.7 37.3992 404C37.3992 404.2 37.4992 404.4 37.4992 404.5C37.5992 404.8 37.6992 405.1 37.6992 405.4C37.7992 405.6 37.7992 405.8 37.8992 405.9C37.9992 406.2 38.0992 406.4 38.0992 406.7C38.1992 406.9 38.1992 407.1 38.2992 407.3C38.3992 407.6 38.3992 407.8 38.4992 408.1C38.5992 408.3 38.5992 408.5 38.6992 408.7C38.7992 408.9 38.7992 409.2 38.8992 409.4C38.9992 409.6 38.9992 409.8 39.0992 410C39.1992 410.2 39.1992 410.5 39.2992 410.7C39.3992 410.9 39.3992 411.1 39.4992 411.2C39.5992 411.4 39.5992 411.6 39.6992 411.8C39.7992 412 39.7992 412.1 39.8992 412.3C39.9992 412.5 39.9992 412.7 40.0992 412.9C40.1992 413.1 40.1992 413.2 40.2992 413.4C40.3992 413.6 40.3992 413.8 40.4992 414C40.5992 414.2 40.5992 414.3 40.6992 414.5C40.7992 414.7 40.7992 414.9 40.8992 415.1C40.9992 415.3 40.9992 415.4 41.0992 415.5C41.1992 415.7 41.1992 415.9 41.2992 416C41.3992 416.1 41.3992 416.3 41.4992 416.4C41.5992 416.6 41.5992 416.7 41.6992 416.9C41.7992 417 41.7992 417.2 41.8992 417.3C41.9992 417.5 41.9992 417.6 42.0992 417.8C42.1992 417.9 42.1992 418.1 42.2992 418.2C42.3992 418.3 42.3992 418.5 42.4992 418.6C42.5992 418.7 42.5992 418.8 42.6992 418.9C42.7992 419 42.7992 419.2 42.8992 419.3C42.9992 419.4 42.9992 419.5 43.0992 419.6C43.1992 419.7 43.1992 419.8 43.2992 420C43.3992 420.1 43.3992 420.2 43.4992 420.3C43.5992 420.4 43.5992 420.5 43.6992 420.6C43.6992 420.7 43.7992 420.8 43.7992 420.8C43.8992 420.9 43.8992 421 43.9992 421.1C43.9992 421.2 44.0992 421.2 44.0992 421.3C44.1992 421.4 44.2992 421.6 44.3992 421.7C45.0992 422.5 45.7992 423.3 46.4992 424C46.6992 424.2 46.8992 424.4 47.0992 424.6C47.7992 425.3 48.3992 425.9 49.0992 426.6C49.1992 426.7 49.1992 426.7 49.2992 426.8C49.9992 427.5 50.7992 428.2 51.4992 428.8C51.6992 429 51.8992 429.1 52.0992 429.3C52.7992 429.9 53.3992 430.4 54.0992 430.9C54.1992 431 54.2992 431.1 54.4992 431.2C55.2992 431.8 55.9992 432.4 56.7992 433C56.9992 433.1 57.1992 433.3 57.3992 433.4C58.0992 433.9 58.6992 434.3 59.3992 434.8C59.5992 434.9 59.6992 435 59.8992 435.1C60.6992 435.6 61.4992 436.1 62.2992 436.6C62.4992 436.7 62.6992 436.8 62.8992 437C63.5992 437.4 64.1992 437.8 64.8992 438.2C65.0992 438.3 65.2992 438.4 65.4992 438.5C66.2992 439 67.0992 439.4 67.8992 439.8C68.0992 439.9 68.2992 440 68.4992 440.1C69.1992 440.4 69.7992 440.8 70.4992 441.1C70.6992 441.2 70.9992 441.3 71.1992 441.4C71.9992 441.8 72.7992 442.1 73.6992 442.5C73.8992 442.6 74.0992 442.7 74.2992 442.7C74.9992 443 75.6992 443.2 76.2992 443.5C76.5992 443.6 76.7992 443.7 77.0992 443.8C77.8992 444.1 78.7992 444.4 79.5992 444.7C79.7992 444.8 79.9992 444.8 80.0992 444.9C80.7992 445.1 81.4992 445.4 82.1992 445.6C82.4992 445.7 82.7992 445.8 83.0992 445.9C83.8992 446.1 84.5992 446.3 85.3992 446.5C85.5992 446.6 85.7992 446.6 86.0992 446.7C86.7992 446.9 87.4992 447.1 88.2992 447.2C88.5992 447.3 88.8992 447.3 89.1992 447.4C89.8992 447.5 90.4992 447.7 91.1992 447.8C91.4992 447.9 91.7992 447.9 91.9992 448C92.7992 448.1 93.4992 448.3 94.2992 448.4C94.5992 448.5 94.9992 448.5 95.2992 448.6C95.8992 448.7 96.4992 448.8 97.0992 448.9C97.3992 448.9 97.6992 449 97.9992 449C98.7992 449.1 99.5992 449.2 100.399 449.3C100.799 449.3 101.099 449.4 101.499 449.4C102.099 449.5 102.599 449.5 103.199 449.6C103.499 449.6 103.899 449.7 104.199 449.7C138.499 452.6 172.199 440.5 185.499 435Z",
    fill: "#0B0F3C"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M142.601 335.9C144.701 315.6 137.101 308.4 132.901 306C132.201 306 131.501 306.1 130.801 306.1C133.601 307.2 144.101 312.7 141.501 336.2C141.901 336.1 142.201 336 142.601 335.9Z",
    fill: "url(#paint73_linear_6686_51309)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M123.201 306.4C122.901 306.4 122.401 306.5 121.801 306.5C124.101 308.4 133.301 317.8 128.701 339.7H128.801C128.801 339.5 128.701 339.3 128.801 339.3C129.001 339.3 129.401 339.3 129.801 339.2C133.901 319.2 126.401 309.5 123.201 306.4Z",
    fill: "url(#paint74_linear_6686_51309)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M331.899 330.5L324.699 325.7H327.499L335.399 330.5H331.899Z",
    fill: "#0B0F3C"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M352.598 330.5L345.398 325.7H348.298L356.098 330.5H352.598Z",
    fill: "#0B0F3C"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M356.099 330.5H352.799L358.499 300.4H361.799L356.099 330.5Z",
    fill: "url(#paint75_linear_6686_51309)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M335.398 330.5H331.898L337.098 300.4H340.598L335.398 330.5Z",
    fill: "url(#paint76_linear_6686_51309)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M367 299.8C367 297.1 365.9 294.8 364.4 294.6H334.1V305H364.4C365.9 304.8 367 302.5 367 299.8Z",
    fill: "url(#paint77_linear_6686_51309)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M476.898 321.1C473.398 312.8 465.698 311.1 462.298 310.9C462.198 310.9 456.998 308 456.898 308C455.798 307.7 454.698 307.5 453.498 307.3C452.398 307.2 451.298 307 450.198 306.9C448.298 306.8 446.398 306.8 444.498 306.8C443.198 306.8 441.898 306.8 440.598 306.6C436.798 306.5 432.998 306.9 429.198 307.6C426.898 308 428.098 309.7 425.798 310.2C423.598 310.7 413.298 312.2 411.298 313C407.198 314.4 380.398 326.3 380.298 325.9C371.198 316.2 364.598 308.2 361.598 305.6C359.798 302.6 361.898 292.2 355.498 290.8C355.398 290.8 354.898 291 354.398 290.9C351.798 290.4 349.798 291.4 349.598 291.4C348.898 291.4 347.998 290.6 346.898 290.6C345.898 290.6 345.298 292 344.998 292.1C344.798 292.1 342.898 291.4 342.298 291.6C342.298 291.6 340.398 292.5 340.398 294.7C340.398 294.7 343.098 294.9 344.098 296.2C346.698 299.7 345.598 301.6 347.898 305.1C349.298 307.2 350.298 308.1 350.298 308.1C350.998 309.8 351.098 312.9 354.598 321.2C356.798 326.5 359.898 332.5 363.498 338.5C367.898 345.7 370.298 352.6 378.598 354.3C383.498 355.3 388.798 353.1 395.398 352.3C399.498 351.8 406.198 349.4 408.998 348.3C410.898 347.5 412.498 346.4 413.098 346.1C413.398 346 409.998 377.1 409.998 380.3C409.998 382.5 409.998 384.8 409.998 387C413.498 387.4 417.098 387.5 420.698 387.5C450.398 387.5 473.898 380.3 488.698 361.7C488.598 360.1 481.998 333 476.898 321.1Z",
    fill: "url(#paint78_linear_6686_51309)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M489.399 337.2C489.399 336.4 489.299 335.6 489.299 334.8C489.299 334.7 489.299 334.6 489.299 334.5C489.399 335.7 489.599 336.9 489.699 338.1C489.699 338.1 489.699 338.2 489.599 338.2C489.599 337.9 489.499 337.6 489.399 337.2Z",
    fill: "#3A4860"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M489.6 340.9C489.6 340.4 489.5 339.9 489.5 339.4C489.7 340.4 489.9 341.4 490 342.5C489.9 341.9 489.7 341.4 489.6 340.9Z",
    fill: "#3A4860"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M489.6 343.3C489.7 343.6 489.7 343.8 489.8 344C489.8 344.4 489.9 344.8 489.9 345.2C489.8 344.8 489.7 344.5 489.6 344.1C489.6 343.9 489.6 343.6 489.6 343.3Z",
    fill: "#3A4860"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M488.9 336.5C488.9 337.1 489 337.7 489 338.4C488.9 338.1 488.9 337.7 488.8 337.4C488.7 336.9 488.6 336.3 488.5 335.7C488.5 335.6 488.6 335.6 488.6 335.5C488.6 335.7 488.7 335.8 488.7 336C488.8 336.1 488.8 336.3 488.9 336.5Z",
    fill: "#3A4860"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M445.2 310.3C461 310.5 472.6 306 474 290C475.8 270 461.8 258.5 446 258.5C430.2 258.5 417.5 271 417.5 286.4C417.5 301.9 425.9 310 445.2 310.3Z",
    fill: "url(#paint79_linear_6686_51309)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M427.098 306.4L425.898 310C425.898 310 437.698 318.8 450.098 318.8C462.498 318.8 462.398 310.9 462.398 310.9L465.898 305.8C465.798 305.7 449.098 315.1 427.098 306.4Z",
    fill: "#262757"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M411.3 312.8C407.2 314.2 380.4 326.1 380.3 325.7C371.2 316 364.6 308 361.6 305.4C361.6 305.4 376 329.2 376.8 329.2C377.7 329.2 378.3 325.9 379.7 327.1C381.1 328.3 379.2 330.1 380.8 330.5C382.4 330.9 410.5 317.9 411.3 316.9C412 315.8 410.8 313.7 413 314.2C415.2 314.7 423.9 314.3 423.9 314.3L426.9 311.1L427.1 306.5L425.9 310.1C423.7 310.5 413.4 312.1 411.3 312.8Z",
    fill: "url(#paint80_linear_6686_51309)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M342.4 295.6H334V294.5H340.5L342.4 295.6Z",
    fill: "url(#paint81_linear_6686_51309)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M365.799 295.6H360.699V294.5H363.899L365.799 295.6Z",
    fill: "url(#paint82_linear_6686_51309)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M334.299 305.1C336.011 305.1 337.399 302.727 337.399 299.8C337.399 296.873 336.011 294.5 334.299 294.5C332.587 294.5 331.199 296.873 331.199 299.8C331.199 302.727 332.587 305.1 334.299 305.1Z",
    fill: "#0B0F3C"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M354.299 290.7C354.199 290.7 352.799 289.8 351.299 290C349.899 290.2 349.499 290.9 349.399 290.9C349.299 290.9 347.999 290.2 346.899 290.2C345.899 290.2 345.099 291.2 345.099 291.2C344.899 291.2 343.799 290.4 342.099 291.1C341.199 291.8 340.899 292.8 340.799 292.9C340.799 293 340.699 293 340.699 293.1C341.599 291.9 342.699 292.1 343.399 292.3C344.699 292.6 346.199 293.5 346.199 293.5C346.199 293.5 345.299 291.9 346.699 291.4C349.399 290.5 351.099 292.9 351.099 292.9C351.099 292.9 350.699 291.2 352.099 290.8C354.299 290.3 355.599 292.6 355.499 292.4C355.299 290.6 357.599 292.2 358.199 293.8C358.499 294.7 359.499 297.2 360.399 299.4C360.399 299 360.299 298.7 360.299 298.3C360.299 298.1 360.299 297.9 360.199 297.7C360.199 297.6 360.199 297.4 360.099 297.3C360.099 297 359.999 296.7 359.899 296.4C359.899 296.3 359.899 296.2 359.799 296.1C359.699 295.8 359.699 295.5 359.599 295.2V295.1C359.499 294.8 359.399 294.5 359.299 294.3C359.299 294.2 359.199 294.2 359.199 294.1C359.099 293.8 358.899 293.5 358.799 293.3C358.799 293.2 358.699 293.2 358.699 293.1C358.499 292.8 358.399 292.6 358.199 292.3C357.999 292.1 357.799 291.9 357.499 291.7L357.399 291.6C357.199 291.4 356.899 291.3 356.599 291.1C356.499 291.1 356.499 291.1 356.399 291C356.099 290.9 355.799 290.7 355.399 290.7C354.799 290.6 354.399 290.7 354.299 290.7Z",
    fill: "url(#paint83_linear_6686_51309)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M476.9 321.1C473.4 312.8 465.7 311.1 462.3 310.9L465.8 305.8C470.4 302.7 473.3 297.7 474 290.1C474.8 281.1 472.4 273.9 468.1 268.6C471.6 286.3 449.9 294.6 449.7 291.8C449 282 445.2 279.9 445.2 279.9C445.2 279.9 445.9 297.7 442 298.8C438.1 299.9 431.5 297.4 431.5 297.4L421.9 301.9C423.5 303.9 425.6 305.6 428.1 306.9C427.7 306.7 427.3 306.6 426.9 306.4L425.7 310C424.8 310.2 424.4 311.3 423.8 314.3H415C415 314.3 418.1 318.1 418.5 322C419.3 330.4 412.6 320.1 409.4 322.7C402.3 328.6 384.4 337.1 377.9 335.6C371.4 334.1 355.3 316.9 354.1 313.1C352.9 309.3 356.6 308 356 307.8C355.4 307.6 352.2 309 351.8 308.3C351.4 307.6 352.3 306.7 352.4 306.5C352.5 306.2 351.6 305.3 350.7 304.2C349.8 303.1 347.8 298.6 346.9 297.1C346 295.6 344 294 342.7 293.9C341.6 293.8 340.8 294.3 340.6 294.4C341.2 294.5 343.2 294.8 344.1 295.9C346.7 299.4 345.6 301.3 347.9 304.8C349.3 306.9 350.3 307.8 350.3 307.8C351 309.5 351.1 312.6 354.6 320.9C356.8 326.2 359.9 332.2 363.5 338.2C367.9 345.4 370.3 352.3 378.6 354C383.5 355 388.8 352.8 395.4 352C399.5 351.5 406.2 349.1 409 348C410.9 347.2 412.5 346.1 413.1 345.8C413.1 345.8 413.1 346 413.1 346.2C413.1 346.2 413.9 346.3 415 346.3C416.1 346.6 417.8 346.7 420.3 346.1C421.3 345.9 423.1 345.3 425.1 344.6L410 380.2L435.3 381.9L482.7 343.3L483.9 342.6C481.8 334.8 479.2 326.4 476.9 321.1Z",
    fill: "#1A1E51"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M437.2 289.5C437 293.5 428.6 302.3 423 303.1C419.2 299.6 417.5 293.5 417.5 286.6C417.5 275.1 425.8 265.3 431 262.9C433.3 265 438.7 275.6 437.2 289.5Z",
    fill: "#0B0F3C"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M421.398 277.8C423.198 273.3 426.098 269.2 429.798 266C436.098 260.6 444.298 258.7 452.398 259.5C450.198 259 447.998 258.7 445.598 258.7C429.998 258.7 417.398 271.2 417.398 286.5C417.398 290 417.898 295.4 419.798 298.9C419.798 298.5 416.698 288.6 421.398 277.8Z",
    fill: "url(#paint84_linear_6686_51309)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M430.299 262.3C430.299 262.3 433.299 265.4 435.199 270.9C437.099 276.4 437.399 282.2 437.399 282.2L439.999 281.9C439.999 281.9 440.699 278.3 438.699 270.1C436.899 262.4 434.499 259.9 434.199 259.9C433.899 259.9 430.499 261.5 430.299 262.3Z",
    fill: "url(#paint85_linear_6686_51309)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M436.599 274.4C435.199 266 432.399 263.6 432.599 262.9C432.699 262.3 434.799 260.4 434.799 260.4C434.499 260.1 434.299 259.9 434.199 259.9C433.899 259.9 430.499 261.5 430.299 262.3C430.299 262.3 433.299 265.4 435.199 270.9C437.099 276.4 437.399 282.2 437.399 282.2H437.599C437.599 281 437.399 278.7 436.599 274.4Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M448.699 294.1C450.799 287.6 448.499 280.9 443.599 279C438.699 277.1 432.999 280.8 430.999 287.2C428.899 293.7 431.199 300.4 436.099 302.3C440.999 304.2 446.599 300.5 448.699 294.1Z",
    fill: "#1A1E51"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M437.199 289.5C438.099 281.1 436.499 273.9 434.499 269.1C431.599 272.5 430.299 278 430.299 278C430.299 278 424.399 283.2 423.999 284C423.599 284.8 425.899 286.9 425.899 287.3C425.899 287.7 425.099 290.1 425.099 290.1L424.799 292.5C424.799 292.5 423.799 294.2 423.599 295.9C423.499 296.9 423.399 299.5 427.499 301.2C432.699 298.3 437.099 292 437.199 289.5Z",
    fill: "url(#paint86_linear_6686_51309)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M447.9 293.5C449.9 287 447.7 280.3 443 278.4C438.3 276.5 432.8 280.2 430.8 286.7C428.8 293.2 431 299.9 435.7 301.8C440.4 303.6 445.9 299.9 447.9 293.5Z",
    fill: "url(#paint87_linear_6686_51309)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M443.999 291.7C445.099 288.2 443.899 284.5 441.299 283.5C438.699 282.5 435.699 284.5 434.599 288C433.499 291.5 434.699 295.2 437.299 296.2C439.899 297.2 442.899 295.2 443.999 291.7Z",
    fill: "#1A1E51"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M358.5 369L420.3 377.4C422.2 370.4 430.3 330.3 440.4 322.7C448.6 316 487.8 315.2 510.1 315.4C517.3 315.5 522.4 322.4 520.4 329.2C513.1 354.5 497 426.6 491.8 430C436.7 466.3 346.1 432.3 346.1 432.3C346.2 422.4 348.4 369 358.5 369Z",
    fill: "url(#paint88_linear_6686_51309)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M421.299 390.1L419.599 382.7C419.599 382.7 365.099 371.2 358.199 372.8C348.899 375.1 346.199 432.4 346.199 432.4C346.199 422.3 348.399 369 358.499 369L420.299 377.4C422.199 370.4 430.299 330.3 440.399 322.7C450.999 314 508.299 315.4 511.199 315.5C511.199 315.5 491.699 316.2 488.399 316.5C455.799 318.8 451.799 320.8 445.399 324.5C432.699 331.8 421.299 390.1 421.299 390.1Z",
    fill: "url(#paint89_linear_6686_51309)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M431.499 286.7C433.499 281.3 437.799 278.3 441.599 278C437.199 277.2 432.599 280.8 430.699 286.6C428.999 292 430.299 297.6 433.499 300.4C429.499 295.8 430.199 290.3 431.499 286.7Z",
    fill: "url(#paint90_linear_6686_51309)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M516.6 326.7C511.6 324 466.9 330.4 458.4 336.1C453.5 339.4 437.1 372 430.5 399.3C421.8 397.4 369.5 383.9 361.1 387.7C351.9 391.7 348 433.1 348 433.1C352.4 434.6 364.7 438.6 380.8 441.9H380.7C381.1 442 381.6 442.1 382 442.2C382.4 442.3 382.7 442.3 383.1 442.4C383.8 442.5 384.5 442.7 385.1 442.8C385.4 442.9 385.8 442.9 386.1 443C386.8 443.1 387.6 443.3 388.4 443.4C388.7 443.4 389 443.5 389.2 443.5C390 443.6 390.8 443.8 391.7 443.9C391.9 443.9 392.2 444 392.4 444C393.3 444.1 394.2 444.3 395.1 444.4C395.3 444.4 395.5 444.5 395.7 444.5C396.6 444.6 397.6 444.8 398.6 444.9C398.8 444.9 398.9 444.9 399.1 445C400.1 445.1 401.1 445.3 402.2 445.4C402.3 445.4 402.4 445.4 402.5 445.4C403.6 445.5 404.7 445.6 405.8 445.8C405.9 445.8 405.9 445.8 406 445.8C407.1 445.9 408.3 446 409.4 446.1H409.5C436.7 448.4 467.7 446 491.9 430.1C497.1 426.7 513 355.2 520.4 329.6C519.4 328.2 517.9 327.4 516.6 326.7Z",
    fill: "#0B0F3C"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M387.3 65.7998H152.6L266.5 209.1L387.3 65.7998Z",
    fill: "url(#paint91_linear_6686_51309)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M280.3 224.4C280.3 225.4 278 226.3 274.3 226.9C272.1 227.2 269.5 227.4 266.6 227.4C263.7 227.4 261.1 227.2 258.9 226.9C255.3 226.4 252.9 225.5 252.9 224.4C252.9 223.4 255.2 222.5 258.9 221.9C261.1 221.6 263.7 221.4 266.6 221.4C269.4 221.4 272.1 221.6 274.3 221.9C277.9 222.5 280.3 223.4 280.3 224.4Z",
    fill: "#121B2E"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M266.601 227.4C269.501 227.4 272.101 227.2 274.301 226.9C276.701 226.5 278.501 226 279.501 225.4C278.501 224.8 276.701 224.3 274.301 223.9C272.101 223.6 269.501 223.4 266.601 223.4C263.701 223.4 261.101 223.6 258.901 223.9C256.501 224.2 254.601 224.8 253.701 225.4C254.701 226 256.501 226.5 258.901 226.9C261.201 227.2 263.801 227.4 266.601 227.4Z",
    fill: "#F4B840"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M266.7 202.8C262.5 202.8 259 206.2 259 210.5V225.6C259 225.9 262.4 226.5 266.7 226.5C271 226.5 274.4 226 274.4 225.6V210.5C274.3 206.2 270.9 202.8 266.7 202.8Z",
    fill: "url(#paint92_linear_6686_51309)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M339.8 224.4C339.8 225.4 337.5 226.3 333.8 226.9C331.6 227.2 329 227.4 326.1 227.4C323.2 227.4 320.6 227.2 318.4 226.9C314.8 226.4 312.4 225.5 312.4 224.4C312.4 223.4 314.7 222.5 318.4 221.9C320.6 221.6 323.2 221.4 326.1 221.4C328.9 221.4 331.6 221.6 333.8 221.9C337.5 222.5 339.8 223.4 339.8 224.4Z",
    fill: "#121B2E"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M326.201 227.4C329.101 227.4 331.701 227.2 333.901 226.9C336.301 226.5 338.101 226 339.101 225.4C338.101 224.8 336.301 224.3 333.901 223.9C331.701 223.6 329.101 223.4 326.201 223.4C323.301 223.4 320.701 223.6 318.501 223.9C316.101 224.2 314.201 224.8 313.301 225.4C314.301 226 316.101 226.5 318.501 226.9C320.701 227.2 323.301 227.4 326.201 227.4Z",
    fill: "#283D7E"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M326.2 202.8C322 202.8 318.5 206.2 318.5 210.5V225.6C318.5 225.9 321.9 226.5 326.2 226.5C330.4 226.5 333.9 226 333.9 225.6V210.5C333.9 206.2 330.5 202.8 326.2 202.8Z",
    fill: "#262757"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M220.8 224.4C220.8 225.4 218.5 226.3 214.8 226.9C212.6 227.2 210 227.4 207.1 227.4C204.2 227.4 201.6 227.2 199.4 226.9C195.8 226.4 193.4 225.5 193.4 224.4C193.4 223.4 195.7 222.5 199.4 221.9C201.6 221.6 204.2 221.4 207.1 221.4C209.9 221.4 212.6 221.6 214.8 221.9C218.4 222.5 220.8 223.4 220.8 224.4Z",
    fill: "#121B2E"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M207.101 227.4C210.001 227.4 212.601 227.2 214.801 226.9C217.201 226.5 219.001 226 220.001 225.4C219.001 224.8 217.201 224.3 214.801 223.9C212.601 223.6 210.001 223.4 207.101 223.4C204.201 223.4 201.601 223.6 199.401 223.9C197.001 224.2 195.101 224.8 194.201 225.4C195.201 226 197.001 226.5 199.401 226.9C201.701 227.2 204.301 227.4 207.101 227.4Z",
    fill: "#283D7E"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M207.2 202.8C203 202.8 199.5 206.2 199.5 210.5V225.6C199.5 225.9 202.9 226.5 207.2 226.5C211.4 226.5 214.9 226 214.9 225.6V210.5C214.8 206.2 211.4 202.8 207.2 202.8Z",
    fill: "#262757"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M266.7 221.5C263.2 221.5 259.3 217.6 259 213.5V225.6C259 225.9 262.4 226.5 266.7 226.5C271 226.5 274.4 226 274.4 225.6V213.5C273.8 218.4 271.2 221.5 266.7 221.5Z",
    fill: "#1A1E51"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M271.401 204.8C271.401 205.4 269.201 205.1 266.701 205.1C264.201 205.1 262.201 205.2 262.201 204.6C262.201 204 264.201 202.8 266.701 202.8C269.101 202.8 271.401 204.1 271.401 204.8Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M329.5 203.5C328.5 203 327.4 202.8 326.2 202.8C322 202.8 318.5 206.2 318.5 210.5V225.6C318.6 226 321.4 226.2 321.4 226.2C321.4 217.3 320.1 208.5 323 205.5C325.1 203.4 327.9 203.2 329.5 203.5Z",
    fill: "url(#paint93_linear_6686_51309)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M203.9 203.5C204.9 203 206 202.8 207.2 202.8C211.4 202.8 214.9 206.2 214.9 210.5V225.6C214.8 226 212 226.2 212 226.2C212 217.3 213.3 208.5 210.4 205.5C208.3 203.4 205.5 203.2 203.9 203.5Z",
    fill: "url(#paint94_linear_6686_51309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6686_51309",
    x1: 339.851,
    y1: 349.981,
    x2: 201.015,
    y2: 131.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6686_51309",
    x1: 270.151,
    y1: 172.109,
    x2: 270.151,
    y2: -28.5602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#232A83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6686_51309",
    x1: 25.5628,
    y1: 152.498,
    x2: 124.123,
    y2: 152.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00595238,
    stopColor: "#7AD2E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6686_51309",
    x1: 417.442,
    y1: 152.498,
    x2: 514.74,
    y2: 152.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#7AD2E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6686_51309",
    x1: 265.333,
    y1: 233.902,
    x2: 265.333,
    y2: 217.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569DD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6686_51309",
    x1: 265.333,
    y1: 234.193,
    x2: 265.333,
    y2: 235.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92DDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "#518DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6686_51309",
    x1: 405.18,
    y1: 319.95,
    x2: 398.924,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6686_51309",
    x1: 396.275,
    y1: 319.95,
    x2: 390.018,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6686_51309",
    x1: 387.464,
    y1: 319.95,
    x2: 381.208,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6686_51309",
    x1: 392.678,
    y1: 323.294,
    x2: 386.422,
    y2: 323.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6686_51309",
    x1: 411.294,
    y1: 323.294,
    x2: 405.038,
    y2: 323.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6686_51309",
    x1: 396.605,
    y1: 326.697,
    x2: 390.349,
    y2: 326.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6686_51309",
    x1: 377.281,
    y1: 319.95,
    x2: 371.025,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6686_51309",
    x1: 382.494,
    y1: 323.294,
    x2: 376.237,
    y2: 323.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6686_51309",
    x1: 386.421,
    y1: 326.697,
    x2: 380.165,
    y2: 326.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6686_51309",
    x1: 367.332,
    y1: 319.95,
    x2: 361.076,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6686_51309",
    x1: 372.545,
    y1: 323.294,
    x2: 366.288,
    y2: 323.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6686_51309",
    x1: 376.472,
    y1: 326.697,
    x2: 370.216,
    y2: 326.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6686_51309",
    x1: 401.399,
    y1: 330.317,
    x2: 395.142,
    y2: 330.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6686_51309",
    x1: 391.216,
    y1: 330.317,
    x2: 384.96,
    y2: 330.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6686_51309",
    x1: 381.267,
    y1: 330.317,
    x2: 375.011,
    y2: 330.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6686_51309",
    x1: 406.371,
    y1: 333.902,
    x2: 400.114,
    y2: 333.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6686_51309",
    x1: 396.942,
    y1: 334.308,
    x2: 379.876,
    y2: 334.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6686_51309",
    x1: 265.01,
    y1: 270.291,
    x2: 269.966,
    y2: 270.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6686_51309",
    x1: 242.006,
    y1: 270.291,
    x2: 246.961,
    y2: 270.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6686_51309",
    x1: 253.508,
    y1: 270.291,
    x2: 258.463,
    y2: 270.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6686_51309",
    x1: 276.513,
    y1: 270.291,
    x2: 281.468,
    y2: 270.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6686_51309",
    x1: 265.01,
    y1: 261.047,
    x2: 269.966,
    y2: 261.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6686_51309",
    x1: 242.006,
    y1: 261.047,
    x2: 246.961,
    y2: 261.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6686_51309",
    x1: 253.508,
    y1: 261.047,
    x2: 258.463,
    y2: 261.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6686_51309",
    x1: 276.513,
    y1: 261.047,
    x2: 281.468,
    y2: 261.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6686_51309",
    x1: 242.239,
    y1: 288.594,
    x2: 246.51,
    y2: 288.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6686_51309",
    x1: 253.925,
    y1: 288.594,
    x2: 258.196,
    y2: 288.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6686_51309",
    x1: 253.616,
    y1: 290.319,
    x2: 258.354,
    y2: 290.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6686_51309",
    x1: 242.006,
    y1: 285.067,
    x2: 246.744,
    y2: 285.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6686_51309",
    x1: 109.546,
    y1: 327.974,
    x2: 236.444,
    y2: 327.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569DD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6686_51309",
    x1: 223.612,
    y1: 328.318,
    x2: 228.612,
    y2: 343.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6686_51309",
    x1: 184.226,
    y1: 319.95,
    x2: 190.482,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6686_51309",
    x1: 193.132,
    y1: 319.95,
    x2: 199.388,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6686_51309",
    x1: 201.943,
    y1: 319.95,
    x2: 208.199,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6686_51309",
    x1: 196.728,
    y1: 323.294,
    x2: 202.984,
    y2: 323.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6686_51309",
    x1: 178.113,
    y1: 323.294,
    x2: 184.369,
    y2: 323.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6686_51309",
    x1: 192.801,
    y1: 326.697,
    x2: 199.057,
    y2: 326.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6686_51309",
    x1: 212.125,
    y1: 319.95,
    x2: 218.381,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6686_51309",
    x1: 206.913,
    y1: 323.294,
    x2: 213.169,
    y2: 323.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6686_51309",
    x1: 202.985,
    y1: 326.697,
    x2: 209.242,
    y2: 326.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6686_51309",
    x1: 222.075,
    y1: 319.95,
    x2: 228.331,
    y2: 319.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6686_51309",
    x1: 216.862,
    y1: 323.294,
    x2: 223.118,
    y2: 323.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6686_51309",
    x1: 212.935,
    y1: 326.697,
    x2: 219.191,
    y2: 326.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6686_51309",
    x1: 188.008,
    y1: 330.317,
    x2: 194.264,
    y2: 330.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6686_51309",
    x1: 198.19,
    y1: 330.317,
    x2: 204.447,
    y2: 330.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6686_51309",
    x1: 183.036,
    y1: 333.902,
    x2: 189.292,
    y2: 333.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6686_51309",
    x1: 192.464,
    y1: 334.308,
    x2: 209.53,
    y2: 334.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23286F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6686_51309",
    x1: 363.818,
    y1: 329.898,
    x2: 307.818,
    y2: 366.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344A9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569DD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6686_51309",
    x1: 301.866,
    y1: 328.317,
    x2: 296.866,
    y2: 343.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6686_51309",
    x1: 308.027,
    y1: 327.352,
    x2: 316.604,
    y2: 327.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6686_51309",
    x1: 435.612,
    y1: 117.689,
    x2: 477.005,
    y2: 146.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.092849,
    stopColor: "#8EDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4361"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_6686_51309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.113 38.0917) rotate(-21.5015) scale(9.97855 9.60585)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3289",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_6686_51309",
    x1: 121.413,
    y1: 126.466,
    x2: 140.676,
    y2: 117.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_6686_51309",
    x1: 295.607,
    y1: 342.241,
    x2: 290.138,
    y2: 342.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_6686_51309",
    x1: 354.205,
    y1: 409.021,
    x2: 348.736,
    y2: 409.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_6686_51309",
    x1: 349.497,
    y1: 369.521,
    x2: 247.426,
    y2: 375.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_6686_51309",
    x1: 141.803,
    y1: 242.509,
    x2: 130.803,
    y2: 324.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_6686_51309",
    x1: 110.46,
    y1: 258.025,
    x2: 80.9603,
    y2: 287.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92DDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "#518DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_6686_51309",
    x1: 112.586,
    y1: 260.337,
    x2: 92.5865,
    y2: 286.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_6686_51309",
    x1: 87.6882,
    y1: 275.562,
    x2: 109.849,
    y2: 275.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_6686_51309",
    x1: 102.062,
    y1: 249.981,
    x2: 92.062,
    y2: 263.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#344A9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_6686_51309",
    x1: 103.311,
    y1: 294.179,
    x2: 216.009,
    y2: 294.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_6686_51309",
    x1: 87.8001,
    y1: 261.716,
    x2: 103.311,
    y2: 261.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_6686_51309",
    x1: 102.87,
    y1: 265.576,
    x2: 80.9322,
    y2: 287.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_6686_51309",
    x1: 82.9337,
    y1: 278.442,
    x2: 95.7941,
    y2: 281.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_6686_51309",
    x1: 16.8521,
    y1: 319.405,
    x2: 136.45,
    y2: 415.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_6686_51309",
    x1: 90.5023,
    y1: 391.374,
    x2: 139.207,
    y2: 352.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_6686_51309",
    x1: 139.233,
    y1: 302.013,
    x2: 136.696,
    y2: 320.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_6686_51309",
    x1: 128.803,
    y1: 301.73,
    x2: 125.958,
    y2: 322.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_6686_51309",
    x1: 358.92,
    y1: 299.796,
    x2: 355.562,
    y2: 332.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_6686_51309",
    x1: 337.873,
    y1: 299.81,
    x2: 334.519,
    y2: 332.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00396825,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E8AA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_6686_51309",
    x1: 351.039,
    y1: 292.989,
    x2: 349.559,
    y2: 307.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010433"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_6686_51309",
    x1: 388.583,
    y1: 266.432,
    x2: 424.077,
    y2: 339.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_6686_51309",
    x1: 422.862,
    y1: 268.35,
    x2: 467.362,
    y2: 301.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92DDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "#518DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_6686_51309",
    x1: 361.586,
    y1: 317.958,
    x2: 427.075,
    y2: 317.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_6686_51309",
    x1: 338.298,
    y1: 294.28,
    x2: 338.108,
    y2: 296.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_6686_51309",
    x1: 363.335,
    y1: 294.454,
    x2: 363.183,
    y2: 295.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_6686_51309",
    x1: 347.46,
    y1: 288.172,
    x2: 351.604,
    y2: 296.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_6686_51309",
    x1: 417.506,
    y1: 278.677,
    x2: 452.474,
    y2: 278.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_6686_51309",
    x1: 431.726,
    y1: 260.479,
    x2: 439.726,
    y2: 279.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_6686_51309",
    x1: 423.124,
    y1: 280.326,
    x2: 441.127,
    y2: 291.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_6686_51309",
    x1: 434.224,
    y1: 280.222,
    x2: 443.686,
    y2: 300.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#569DD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#2A3E95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_6686_51309",
    x1: 525.814,
    y1: 318.199,
    x2: 403.435,
    y2: 416.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121650"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_6686_51309",
    x1: 452.4,
    y1: 393.051,
    x2: 400.637,
    y2: 351.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4406,
    stopColor: "#7AD2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_6686_51309",
    x1: 433.462,
    y1: 280.35,
    x2: 440.609,
    y2: 297.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2781,
    stopColor: "#99D5D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5594,
    stopColor: "#7AD2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_6686_51309",
    x1: 269.948,
    y1: 206.762,
    x2: 269.948,
    y2: 54.4691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_6686_51309",
    x1: 266.663,
    y1: 202.8,
    x2: 266.663,
    y2: 226.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_6686_51309",
    x1: 318.015,
    y1: 212.459,
    x2: 323.014,
    y2: 214.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_6686_51309",
    x1: 217.13,
    y1: 209.949,
    x2: 211.213,
    y2: 213.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE7C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpIllNew);
export default __webpack_public_path__ + "static/media/sign_up_ill_new.c818421117b7db030e704b008295e0f6.svg";
export { ForwardRef as ReactComponent };